var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildinghashtagAmico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-68",
    d: "M76.49,451.93c-95.82-60.07-95.82-157.46,0-217.52s251.19-60.07,347,0,95.82,157.45,0,217.52S172.32,512,76.49,451.93Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.28,324.76a.37.37,0,0,1-.21-.26c-3.87-15.66-19.13-25.1-25.64-29.14-1.05-.65-1.88-1.16-2.43-1.55a7.87,7.87,0,0,1-3.55-6.89,6.77,6.77,0,0,1,4-5.49c5.73-2.88,16.32,3.16,24.1,13.74,10.91,14.83,8.74,27.32,8.72,27.45a.42.42,0,0,1-.24.29l-4.39,1.86a.42.42,0,0,1-.15,0A.37.37,0,0,1,54.28,324.76Zm-4.4-29.11c-7.56-10.28-17.71-16.21-23.1-13.51A5.93,5.93,0,0,0,23.24,287a7.09,7.09,0,0,0,3.23,6.18c.52.37,1.34.88,2.38,1.52,6.53,4.05,21.75,13.47,25.88,29.18l3.75-1.6C58.71,320.6,59.81,309.14,49.88,295.65Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,323.75h0a.4.4,0,0,0,.34-.45c-2.47-18.6-18-34.53-27.22-36.9a.4.4,0,0,0-.2.78c9.1,2.34,24.29,18.59,26.63,36.23A.41.41,0,0,0,57,323.75Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.84,322.94a.33.33,0,0,0,.17,0l3-1.4a.4.4,0,0,0,.22-.3c0-.19,2.8-18.74-4.84-42-3.89-11.86-12.78-22.64-21.13-25.66a12,12,0,0,0-11,.9,6,6,0,0,0-3.09,4.31c-.6,4.71,5.11,10.72,11.16,17.09,4.23,4.45,8.6,9.06,10.93,13.36a.4.4,0,1,0,.7-.38c-2.38-4.39-6.79-9-11.05-13.53C28,269.06,22.41,263.18,23,258.85a5.18,5.18,0,0,1,2.73-3.74A11.28,11.28,0,0,1,36,254.29c8.14,2.94,16.82,13.52,20.64,25.16,7.15,21.76,5.12,39.33,4.84,41.42l-2.76,1.31a.4.4,0,0,0-.19.53A.39.39,0,0,0,58.84,322.94Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9,311.54h0a.39.39,0,0,0,.37-.42c-2-29.05-21.51-49.6-26.84-52.83a.41.41,0,0,0-.55.13A.39.39,0,0,0,31,259c5.26,3.18,24.47,23.47,26.46,52.2A.4.4,0,0,0,57.9,311.54Z",
    style: {
      fill: "#FB923C"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-68"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-68",
    cx: 407.77,
    cy: 293.35,
    rx: 60.91,
    ry: 35.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-68",
    cx: 105.44,
    cy: 340.77,
    rx: 64.35,
    ry: 37.15,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-68",
    d: "M112.89,394.49l186.5-107.68a11.12,11.12,0,0,1,10,0l91.06,52.58c3.74,2.16,3.74,5.7,0,7.85l-185.32,107a9.77,9.77,0,0,1-8.84,0l-93.43-54C110.13,398.69,110.13,396.08,112.89,394.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-68",
    d: "M65.9,414.91l10.94-6.35a13.18,13.18,0,0,1,12,0l3.81,2.2,14.24-8.22a5.17,5.17,0,0,1,4.66,0l.09.05c1.29.75,1.29,1.95,0,2.69l-14.24,8.22.79.46c3.3,1.91,3.31,5,0,6.91l-11,6.35-16,9.23L49.91,424.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-68",
    d: "M432.4,409.52l20.22-11.67c.6-.35.6-.91,0-1.25l-5-2.86a2.37,2.37,0,0,0-2.17,0l-20.22,11.67c-.6.35-.6.91,0,1.25l2.48,1.43-25.38,14.66c-.6.34-.35.46-.07.62s.49.31,1.09,0l25.38-14.65,1.46.84A2.37,2.37,0,0,0,432.4,409.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-68",
    d: "M465.15,410.4l-5.95-3.58a2.09,2.09,0,0,0-1.93,0l-22.36,12.88a.59.59,0,0,0,0,1.11l1,.56-32.14,18.29-.05,0a1.4,1.4,0,0,0-1.15-.05,9.52,9.52,0,0,1-4.3.95,5.76,5.76,0,0,1-4.55-5.54,4.63,4.63,0,0,0-.42,5.09,9.52,9.52,0,0,0,4,4.33l1.12.66,4.12,2.42a2.84,2.84,0,0,0,1.21.33h.81a3,3,0,0,1,1.21.34l2,.93-1.29.74a.59.59,0,0,0,0,1.12l2.29,1.32a2.14,2.14,0,0,0,1.94,0l6.52-3.76a.59.59,0,0,0,0-1.12l-2.29-1.32a2.14,2.14,0,0,0-1.94,0l-1.15.66s-.55-.23-.86-.41l-1-.57a1.29,1.29,0,0,1-.54-.88l-1.93-2.33,32.73-18.64.87.52a2,2,0,0,0,1.84-.05l22.2-12.83A.6.6,0,0,0,465.15,410.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-68",
    d: "M28.78,395.91c10.35,6,27.12,6,37.47,0s10.34-15.66,0-21.63-27.12-6-37.47,0S18.44,389.94,28.78,395.91Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tools--inject-68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screwdriver--inject-68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--screwdriver--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.21,397.48l4.32,7.48,14.55-8.41a2.09,2.09,0,0,0,1-2,6.74,6.74,0,0,0-3.06-5.29,2.11,2.11,0,0,0-2.16-.21h0Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.34,399h0c-.06,1.14-1.67,1.38-1.67,1.38l3.05,5.29s1-1.25,2-.76h0c1.51.65,2.67-.16,2.67-1.95a6.73,6.73,0,0,0-3.05-5.29C433.81,396.8,432.53,397.4,432.34,399Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.34,399h0c-.06,1.14-1.67,1.38-1.67,1.38l3.05,5.29s1-1.25,2-.76h0c1.51.65,2.67-.16,2.67-1.95a6.73,6.73,0,0,0-3.05-5.29C433.81,396.8,432.53,397.4,432.34,399Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.4,400.19a3.06,3.06,0,0,1-.73.22l3.05,5.29a3.11,3.11,0,0,1,.56-.51A6.8,6.8,0,0,0,431.4,400.19Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.49,400.79l.25.44a3.36,3.36,0,0,0-.13.95,6.74,6.74,0,0,0,3.06,5.28,2.92,2.92,0,0,0,.88.36l.26.45,1-.59h0a2.16,2.16,0,0,0,.89-2,6.77,6.77,0,0,0-3.05-5.29,2.16,2.16,0,0,0-2.16-.21h0Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.7,406.29a6.76,6.76,0,0,0-3.05-5.29c-1.69-1-3-.18-3,1.76a6.73,6.73,0,0,0,3,5.29C431.33,409,432.7,408.24,432.7,406.29Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.7,406.29a6.76,6.76,0,0,0-3.05-5.29c-1.69-1-3-.18-3,1.76a6.73,6.73,0,0,0,3,5.29C431.33,409,432.7,408.24,432.7,406.29Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.46,407.09a5.29,5.29,0,0,0,.76.67l.71-2-.86-.63Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.57,392.44h0a.84.84,0,0,1-.3,1.15l-10.4,6a.84.84,0,0,1-1.15-.31h0a.84.84,0,0,1,.3-1.15l10.4-6A.84.84,0,0,1,450.57,392.44Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.7,390.21h0a.49.49,0,0,1,0,.86l-10.59,6.12a1.16,1.16,0,0,1-1.23-.14h0a.49.49,0,0,1,0-.86l10.59-6.12A1.16,1.16,0,0,1,448.7,390.21Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.57,395.19h0c-.07-.43-.42-.61-.76-.4l-10.6,6.11a1.14,1.14,0,0,0-.49,1.13h0a.49.49,0,0,0,.76.4l10.6-6.12A1.14,1.14,0,0,0,451.57,395.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.87,418.62v2L408,419a7.86,7.86,0,0,1,2-2.46l19.34-11.16.59-1.69-.59-.35L410,414.51a2,2,0,0,1-2-.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.47,419v2l5.09-1.65a7.93,7.93,0,0,1,2-2.46l19.34-11.17v-2l-19.34,11.16a2,2,0,0,1-2-.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.47 421 402.87 420.66 402.87 418.62 403.47 418.97 403.47 421",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.87 418.62 403.47 418.97 408.56 414.75 407.96 414.4 402.87 418.62",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hammer--inject-68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--hammer--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460.25,402.8a6.51,6.51,0,0,1,2.9,5.09,2.06,2.06,0,0,1-.89,1.9L442.66,421l-4.09-7.19,19.59-11.16A2.05,2.05,0,0,1,460.25,402.8Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.67,412.87a7.46,7.46,0,0,1,3.34,5.86,2.34,2.34,0,0,1-1,2.18l-1.23.7L438,413.34l1.23-.7A2.33,2.33,0,0,1,441.67,412.87Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.67,412.87a7.46,7.46,0,0,1,3.34,5.86,2.34,2.34,0,0,1-1,2.18l-1.23.7L438,413.34l1.23-.7A2.33,2.33,0,0,1,441.67,412.87Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.75,419.44c0,2.15-1.53,3-3.38,1.93a7.46,7.46,0,0,1-3.34-5.86c0-2.15,1.53-3,3.38-1.92A7.44,7.44,0,0,1,443.75,419.44Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.39,415.78a3.28,3.28,0,0,1,1.46,2.56,1.05,1.05,0,0,1-.45,1l-33.17,18.88-2.06-3.62,33.17-18.88A1,1,0,0,1,440.39,415.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.56,437l.67,1.18L441.4,419.3a1.05,1.05,0,0,0,.45-1,2.43,2.43,0,0,0-.14-.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,436.67a4.59,4.59,0,0,0,.49,2.23,8.65,8.65,0,0,0,3.6,3.89l1,.59,3.7,2.17a2.6,2.6,0,0,0,1.09.29h.72a2.4,2.4,0,0,1,1.08.3l2,1a.82.82,0,0,0,.92-.11l1.8-1.79a.52.52,0,0,0,.16-.32c0-.15,0-5.29,0-5.38a.41.41,0,0,0-.22-.45l-.88-.51a1.12,1.12,0,0,1-.5-.88v-1a1.1,1.1,0,0,0-.5-.87l-4.64-2.72a1.28,1.28,0,0,0-1-.05,8.54,8.54,0,0,1-3.87.85,5.18,5.18,0,0,1-4.08-5,4,4,0,0,0-.87,2.46C394,432,394,435.24,394,436.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.36,439.05l-.88-.51a1.12,1.12,0,0,1-.5-.88v-1a1.1,1.1,0,0,0-.5-.87l-4.64-2.72a1.28,1.28,0,0,0-1-.05,8.54,8.54,0,0,1-3.87.85,5.18,5.18,0,0,1-4.08-5,4.14,4.14,0,0,0-.37,4.56,8.54,8.54,0,0,0,3.6,3.89l1,.59,3.7,2.17a2.52,2.52,0,0,0,1.08.29h.73a2.56,2.56,0,0,1,1.08.29l2,.95a.8.8,0,0,0,.92-.1l1.81-1.79A.42.42,0,0,0,410.36,439.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.23,439.2a7.86,7.86,0,0,0-3.61,6.16,2.48,2.48,0,0,0,1.05,2.32l3.53,2.07,5.1-8.71L411.78,439A2.45,2.45,0,0,0,409.23,439.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.17,447.44c0,2.28,1.58,3.21,3.56,2.08a7.89,7.89,0,0,0,3.61-6.16c0-2.27-1.58-3.21-3.56-2.08A7.9,7.9,0,0,0,409.17,447.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.52,439.94a2.06,2.06,0,0,1,.92,1.63.67.67,0,0,1-.28.61l-.93.53-1.31-2.3.93-.53A.66.66,0,0,1,399.52,439.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.5,442.1c0,.6-.42.84-.94.54a2.06,2.06,0,0,1-.92-1.63c0-.6.42-.83.94-.53A2.05,2.05,0,0,1,399.5,442.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,433.85a10,10,0,0,0,2,4,5.43,5.43,0,0,1-2-2.5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.93,405.79h0a.77.77,0,0,1-.29,1l-14.8,8.42a.77.77,0,0,1-1-.29h0a.77.77,0,0,1,.29-1.05l14.79-8.42A.78.78,0,0,1,460.93,405.79Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.22,403.73h0a.45.45,0,0,1,0,.79l-15,8.52a1,1,0,0,1-1.12-.13h0a.45.45,0,0,1,0-.79l15-8.52A1,1,0,0,1,459.22,403.73Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.83,408.31h0a.45.45,0,0,0-.7-.37l-15,8.52a1.07,1.07,0,0,0-.46,1h0a.46.46,0,0,0,.7.37l15-8.53A1,1,0,0,0,461.83,408.31Z",
    style: {
      opacity: 0.2
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--paint-pot--inject-68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--paint-pot--inject-68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--paint-pot--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.13,350.19l-44.26-.61-.38,33.06h0c0,3.27,2.09,6.56,6.38,9.11,8.59,5.08,22.61,5.23,31.31.33,4.38-2.47,6.57-5.75,6.57-9.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.46,340.63c-8.7,4.89-8.78,13-.2,18.07s22.61,5.23,31.31.34,8.78-13,.19-18.08S41.16,335.73,32.46,340.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.23,350a5.49,5.49,0,0,1-.31,1.73c-.68,2.08-2.48,4-5.3,5.59a30.2,30.2,0,0,1-14.74,3.32,30,30,0,0,1-14.64-3.63c-2.72-1.61-4.5-3.57-5.13-5.59a5.61,5.61,0,0,1-.31-1.85c.05-2.7,2-5.3,5.61-7.3A29.56,29.56,0,0,1,48.12,339a30,30,0,0,1,14.67,3.63C66.33,344.72,68.26,347.34,68.23,350Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.92,351.77c-.68,2.08-2.48,4-5.3,5.59a30.2,30.2,0,0,1-14.74,3.32,30,30,0,0,1-14.64-3.63c-2.72-1.61-4.5-3.57-5.13-5.59.68-2.07,2.48-4,5.3-5.56a29.78,29.78,0,0,1,14.71-3.35,30.07,30.07,0,0,1,14.67,3.66C65.51,347.83,67.27,349.75,67.92,351.77Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.62,357.36a15.57,15.57,0,0,0,2-1.33c-8.08,4.34-22,2.52-26.3-.89s-4.92-9.22,2.12-11.82a25,25,0,0,0-7,2.58c-2.82,1.56-4.62,3.49-5.3,5.56.63,2,2.41,4,5.13,5.59a30,30,0,0,0,14.64,3.63A30.2,30.2,0,0,0,62.62,357.36Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.44,363.73c1-.55,1.75-.09,1.73,1a3.86,3.86,0,0,1-1.78,3c-1,.55-1.74.09-1.73-1A3.84,3.84,0,0,1,57.44,363.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8,355.94c-2.43,4.79-7.27,13.11-1,17.76l.77.53,0,2.31c-.63-.38-1.28-.82-1.9-1.27-9.4-7,1.2-21.74,1.66-22.48a.87.87,0,0,1,.53-.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.26,366.2c-.26.55-7.1,10.54-18.35,13.16a16.52,16.52,0,0,1-3.88.46,19.56,19.56,0,0,1-10.47-3.28l0-2.31c4.65,3.23,9.32,4.34,13.9,3.28,10.38-2.44,17-12.08,17.07-12.2a1,1,0,0,1,1.3-.41A.93.93,0,0,1,58.26,366.2Z",
    style: {
      fill: "#e0e0e0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Brush--inject-68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--brush--inject-68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--brush--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.9,414.4l20.66-11.89a1.56,1.56,0,0,0,.65-1.44,4.92,4.92,0,0,0-2.21-3.84,1.55,1.55,0,0,0-1.57-.15L84.77,409Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.09 405.91 96.35 409.54 87.9 414.4 84.77 408.97 90.09 405.91",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.63,415.78l4.2-2.43-4.2-2.42,8.64-5a10.42,10.42,0,0,1,9.42,0l7.38,4.27A3.47,3.47,0,0,1,94,412.76c0,.1,0,4.27,0,5.18a3.34,3.34,0,0,1-1.93,2.57l-8.64,5Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.63,415.78l4.2-2.43-4.2-2.42,8.64-5a10.42,10.42,0,0,1,9.42,0l7.38,4.27A3.47,3.47,0,0,1,94,412.76c0,.1,0,4.27,0,5.18a3.34,3.34,0,0,1-1.93,2.57l-8.64,5Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.07,410.2l-7.38-4.27a10.42,10.42,0,0,0-9.42,0l-8.64,5,16.79,9.72,8.64-5C94.67,414.15,94.67,411.71,92.07,410.2Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.42 420.65 66.63 410.93 54.02 418.19 70.81 427.91 83.42 420.65",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.42 420.65 70.81 427.91 70.81 432.76 83.42 425.5 83.42 420.65",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.17 418.48 70.38 408.76 72.1 407.77 88.98 417.44 87.17 418.48",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.17 418.48 87.16 423.34 88.97 422.29 88.98 417.44 87.17 418.48",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.66,430.55s2.3-3,1.07-5.47l-4.92,2.83v4.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.73,425.08a6,6,0,0,0-3.44-4.62c-2.29-1-7.16,1-9.17-2.26-1.42-2.31.14-5.33.14-5.33L54,418.19l16.79,9.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.02 418.19 54.01 423.04 70.81 432.76 70.81 427.91 54.02 418.19",
    style: {
      fill: "#263238"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Like--inject-68",
    d: "M61.73,212.43A4.51,4.51,0,0,0,60.67,211a3.45,3.45,0,0,0,.44-3.54,3.07,3.07,0,0,0-2.3-1.8,3.58,3.58,0,0,0-.18-2.65,3.3,3.3,0,0,0-4.34-1.65l-7.37,3.49a11.81,11.81,0,0,0-3.83-6.3,4.33,4.33,0,0,0-5.37-.27c-.85.64-.71,1.21-.6,1.43s.27.52.51,1a22.51,22.51,0,0,1,2,4.21c0,.71-.59,5.18-1,8a.53.53,0,0,0,.05.33l7.11,15a.56.56,0,0,0,.66.3l.09,0,13.28-6.28a3.62,3.62,0,0,0,2-4.67,6.36,6.36,0,0,0-.86-1.34A3.82,3.82,0,0,0,61.73,212.43Zm-1.9,3.14a.59.59,0,0,0-.32.44.55.55,0,0,0,.19.5A4.91,4.91,0,0,1,60.77,218a2.52,2.52,0,0,1-1.49,3.16l-12.76,6-6.79-14.34c.19-1.25,1.07-7.08,1-8.08-.05-.84-1-2.7-2.12-4.68-.17-.32-.32-.59-.41-.77a2.73,2.73,0,0,1,1.39-.67,3,3,0,0,1,2.72.7A10.76,10.76,0,0,1,46,205.72a.54.54,0,0,0,.3.4.55.55,0,0,0,.5,0l8-3.8a2.15,2.15,0,0,1,2.82,1.12,2.42,2.42,0,0,1-.15,2.4.56.56,0,0,0,0,.63.59.59,0,0,0,.59.24,1.86,1.86,0,0,1,2,1.18,2.22,2.22,0,0,1-.63,2.66.56.56,0,0,0-.22.51.58.58,0,0,0,.32.45,3,3,0,0,1,1.16,1.39A2.56,2.56,0,0,1,59.83,215.57Zm-22.29-2.41a.56.56,0,0,0-.75-.27L31,215.63a.57.57,0,0,0-.29.32.58.58,0,0,0,0,.43L39,233.85a.58.58,0,0,0,.67.3l.09,0,5.78-2.74a.57.57,0,0,0,.29-.32.61.61,0,0,0,0-.44Zm2.24,19.69L32,216.41l4.76-2.26,7.78,16.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--like--inject-68",
    d: "M360.33,44.34c0-.84,1.71-3.82,2-4.38s-2.34-2-4.1-.31a9,9,0,0,0-2.95,5.46L348.7,42.2a2.19,2.19,0,0,0-2.86,1.18,2.41,2.41,0,0,0,.21,2.38A2,2,0,0,0,343.92,47a2.24,2.24,0,0,0,.71,2.69,2.73,2.73,0,0,0-1.12,1.37,2.47,2.47,0,0,0,1,2.73,4.33,4.33,0,0,0-.94,1.35A2.48,2.48,0,0,0,345,58.28l10.81,4.82,5.46-12.22S360.3,45.17,360.33,44.34ZM363,51.22l-6.35,14.23,4.71,2.1,6.35-14.23Zm-3,14a.93.93,0,1,1,.92-.92A.91.91,0,0,1,360,65.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Heart--inject-68",
    d: "M463.23,221.26a.82.82,0,0,1-.73-.2l-3.36-3.21h0c-2.58-2.46-9.44-9-7.9-16.92a8.12,8.12,0,0,1,15.76-.65,8.18,8.18,0,0,1,8-2.95,8.09,8.09,0,0,1,6.39,9.48c-1.55,7.93-10.36,11.4-13.68,12.71l-4.32,1.7Zm-3-4.59,3,2.84,3.83-1.51c3.09-1.22,11.3-4.45,12.68-11.5a6.47,6.47,0,0,0-5.1-7.57,6.49,6.49,0,0,0-7.4,4.27.82.82,0,0,1-1.59-.31,6.48,6.48,0,0,0-12.82-1.64c-1.38,7.05,5,13.13,7.41,15.42Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--heart--inject-68",
    d: "M57.36,96.65h-.13l-5.39-.73c-4.14-.57-15.14-2.07-19.11-10.67A9.51,9.51,0,0,1,47.26,73.82a9.51,9.51,0,0,1,18.12-3.65c4,8.6-2,17.94-4.28,21.46l-2.94,4.58A1,1,0,0,1,57.36,96.65Zm-16-23a7.58,7.58,0,0,0-6.9,10.74C38,92.08,48.24,93.48,52.1,94h0l4.78.65,2.61-4.06c2.1-3.28,7.68-12,4.15-19.62A7.59,7.59,0,0,0,49.5,76.42.94.94,0,0,1,49,77.57a1,1,0,0,1-1.21-.35A7.56,7.56,0,0,0,41.37,73.7Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Friend--inject-68",
    d: "M462.37,107.74a4.77,4.77,0,1,0-3.16-5.95A4.77,4.77,0,0,0,462.37,107.74Zm-10.3-5.89a3.42,3.42,0,1,0-2.27-4.27A3.42,3.42,0,0,0,452.07,101.85ZM468.17,120l.36-4.06a4.9,4.9,0,0,0-3.46-5.11l-6.64-2a4.91,4.91,0,0,0-5.73,2.3l-2,3.57a1.27,1.27,0,0,0,.74,1.83l15.08,4.61A1.26,1.26,0,0,0,468.17,120ZM456.6,106.54a3.5,3.5,0,0,0-2.46-2.91l-4.78-1.46a3.54,3.54,0,0,0-4.11,1.64L444,106.35c-.46.84-.4,1.11.51,1.39l6.26,1.93A6.31,6.31,0,0,1,456.6,106.54Zm21.88-.19a3.42,3.42,0,1,0-4.28,2.27A3.43,3.43,0,0,0,478.48,106.35Zm-7.53,9.5,6.26,1.9c.92.28,1.11.09,1.2-.87l.35-2.82a3.54,3.54,0,0,0-2.49-3.66l-4.77-1.46a3.46,3.46,0,0,0-3.67,1A6.3,6.3,0,0,1,471,115.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--friend--inject-68",
    d: "M40.16,156.54a4.46,4.46,0,1,0-5.41-3.25A4.46,4.46,0,0,0,40.16,156.54Zm-11.09.25a3.21,3.21,0,1,0-3.89-2.33A3.21,3.21,0,0,0,29.07,156.79Zm21.63,6.74L49,160.1a4.59,4.59,0,0,0-5.23-2.43l-6.3,1.58A4.6,4.6,0,0,0,34,163.86l.14,3.81a1.19,1.19,0,0,0,1.47,1.11l14.3-3.58A1.19,1.19,0,0,0,50.7,163.53ZM35,158.36a3.26,3.26,0,0,0-3.37-1.15l-4.53,1.13a3.31,3.31,0,0,0-2.5,3.31l.19,2.65c0,.89.21,1.08,1.08.87l5.94-1.48A5.89,5.89,0,0,1,35,158.36Zm17.44-10.71a3.21,3.21,0,1,0-2.33,3.89A3.21,3.21,0,0,0,52.39,147.65Zm-1.46,11.24,5.94-1.49c.87-.22.93-.47.54-1.28l-1.08-2.42A3.31,3.31,0,0,0,52.57,152L48,153.09a3.28,3.28,0,0,0-2.44,2.61A5.88,5.88,0,0,1,50.93,158.89Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--social-media-icons--inject-68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--social-icon--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.81,412.71l21.71-12.53a7.42,7.42,0,0,1,6.74,0l2.74,1.58a7.44,7.44,0,0,1,3.37,5.84v25.07A7.4,7.4,0,0,1,333,438.5L311.29,451a7.48,7.48,0,0,1-6.74,0l-2.74-1.58a7.46,7.46,0,0,1-3.37-5.84V418.55A7.46,7.46,0,0,1,301.81,412.71Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,412.71l21.71-12.53a7.42,7.42,0,0,1,6.74,0l2.74,1.58a7.44,7.44,0,0,1,3.37,5.84v25.07A7.4,7.4,0,0,1,333,438.5L311.29,451a7.48,7.48,0,0,1-6.74,0l-2.74-1.58a7.46,7.46,0,0,1-3.37-5.84V418.55A7.46,7.46,0,0,1,301.81,412.71Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.29,418.19,333,405.65c1.87-1.07,3.37-.2,3.37,2v25.07A7.4,7.4,0,0,1,333,438.5L311.29,451c-1.86,1.07-3.37.2-3.37-2V424A7.43,7.43,0,0,1,311.29,418.19Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.29,418.19,333,405.65c1.87-1.07,3.37-.2,3.37,2v25.07A7.4,7.4,0,0,1,333,438.5L311.29,451c-1.86,1.07-3.37.2-3.37-2V424A7.43,7.43,0,0,1,311.29,418.19Z",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.44,443.62a7.46,7.46,0,0,0,3.37,5.84l2.74,1.58a7.57,7.57,0,0,0,6.17.27c-1.59.6-2.8-.29-2.8-2.22V424a6.91,6.91,0,0,1,1-3.32l-9.48-5.47a6.85,6.85,0,0,0-1,3.32Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.44,443.62a7.46,7.46,0,0,0,3.37,5.84l2.74,1.58a7.57,7.57,0,0,0,6.17.27c-1.59.6-2.8-.29-2.8-2.22V424a6.91,6.91,0,0,1,1-3.32l-9.48-5.47a6.85,6.85,0,0,0-1,3.32Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.67,430.16a24.73,24.73,0,0,0,2.17-10.3,19.13,19.13,0,0,0,1.79-3.49,12.32,12.32,0,0,1-2.05,1.93,9.6,9.6,0,0,0,1.57-3.54,14.23,14.23,0,0,1-2.27,2.47,2.19,2.19,0,0,0-2.61,0c-2.3,1.33-4,5.17-3.47,7.85-3,1.51-5.6,1.14-7.36-.73-.93,2.68-.48,5.22,1.11,5.72a2.59,2.59,0,0,1-1.62.34c0,2.22,1.15,3.6,2.86,3.07a4.38,4.38,0,0,1-1.61,1,2.1,2.1,0,0,0,3.33,1.38,12.27,12.27,0,0,1-5.28,5,7.09,7.09,0,0,0,5.47-1c3.53-2,6.24-5.72,8-9.71",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--social-icon--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.79,383.26l21.71-12.54a7.48,7.48,0,0,1,6.74,0l2.75,1.59a7.45,7.45,0,0,1,3.37,5.83v25.07a7.45,7.45,0,0,1-3.37,5.84l-21.72,12.54a7.48,7.48,0,0,1-6.74,0L352.79,420a7.45,7.45,0,0,1-3.37-5.83V389.1A7.45,7.45,0,0,1,352.79,383.26Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.79,383.26l21.71-12.54a7.48,7.48,0,0,1,6.74,0l2.75,1.59a7.45,7.45,0,0,1,3.37,5.83v25.07a7.45,7.45,0,0,1-3.37,5.84l-21.72,12.54a7.48,7.48,0,0,1-6.74,0L352.79,420a7.45,7.45,0,0,1-3.37-5.83V389.1A7.45,7.45,0,0,1,352.79,383.26Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.36,378.14c0-2.14-1.51-3-3.37-1.94l-21.72,12.53a7.46,7.46,0,0,0-3.37,5.84v25.07c0,2.15,1.51,3,3.37,1.95L384,409.05a7.45,7.45,0,0,0,3.37-5.84Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.36,378.14c0-2.14-1.51-3-3.37-1.94l-21.72,12.53a7.46,7.46,0,0,0-3.37,5.84v25.07c0,2.15,1.51,3,3.37,1.95L384,409.05a7.45,7.45,0,0,0,3.37-5.84Z",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.42,414.17a7.45,7.45,0,0,0,3.37,5.83l2.74,1.59a7.57,7.57,0,0,0,6.17.27c-1.59.6-2.8-.3-2.8-2.22V394.57a6.91,6.91,0,0,1,1-3.32l-9.48-5.48a6.92,6.92,0,0,0-1,3.33Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.42,414.17a7.45,7.45,0,0,0,3.37,5.83l2.74,1.59a7.57,7.57,0,0,0,6.17.27c-1.59.6-2.8-.3-2.8-2.22V394.57a6.91,6.91,0,0,1,1-3.32l-9.48-5.48a6.92,6.92,0,0,0-1,3.33Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.64,411.65l3.62-2.09v-12.1l2.53-1.46.27-4.2-2.8,1.61v-2.3c0-1,.15-1.42.84-1.82l2-1.13V384l-2.51,1.45a7.36,7.36,0,0,0-3.91,6.87v3.22l-1.88,1.09v4.1l1.88-1.09Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--social-icon--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.84,353.8l21.71-12.53a7.42,7.42,0,0,1,6.74,0l2.74,1.58a7.46,7.46,0,0,1,3.37,5.84v25.07A7.46,7.46,0,0,1,435,379.6l-21.71,12.53a7.48,7.48,0,0,1-6.74,0l-2.74-1.58a7.44,7.44,0,0,1-3.37-5.84V359.64A7.44,7.44,0,0,1,403.84,353.8Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.84,353.8l21.71-12.53a7.42,7.42,0,0,1,6.74,0l2.74,1.58a7.46,7.46,0,0,1,3.37,5.84v25.07A7.46,7.46,0,0,1,435,379.6l-21.71,12.53a7.48,7.48,0,0,1-6.74,0l-2.74-1.58a7.44,7.44,0,0,1-3.37-5.84V359.64A7.44,7.44,0,0,1,403.84,353.8Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.4,348.69c0-2.15-1.51-3-3.37-1.95l-21.71,12.54a7.45,7.45,0,0,0-3.37,5.83v25.07c0,2.15,1.51,3,3.37,1.95L435,379.6a7.46,7.46,0,0,0,3.37-5.84Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.4,348.69c0-2.15-1.51-3-3.37-1.95l-21.71,12.54a7.45,7.45,0,0,0-3.37,5.83v25.07c0,2.15,1.51,3,3.37,1.95L435,379.6a7.46,7.46,0,0,0,3.37-5.84Z",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.47,384.71a7.44,7.44,0,0,0,3.37,5.84l2.74,1.58a7.51,7.51,0,0,0,6.16.27c-1.58.6-2.79-.29-2.79-2.22V365.11a6.91,6.91,0,0,1,1-3.32l-9.49-5.47a6.83,6.83,0,0,0-1,3.32Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.47,384.71a7.44,7.44,0,0,0,3.37,5.84l2.74,1.58a7.51,7.51,0,0,0,6.16.27c-1.58.6-2.79-.29-2.79-2.22V365.11a6.91,6.91,0,0,1,1-3.32l-9.49-5.47a6.83,6.83,0,0,0-1,3.32Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,360.7c2.23-1.28,2.49-1.43,3.37-1.88a3.77,3.77,0,0,1,1.54-.51,1.34,1.34,0,0,1,1,.28,1.75,1.75,0,0,1,.62.92,6.22,6.22,0,0,1,.29,1.89c0,1.15,0,1.49,0,4.46s0,3.31,0,4.51a10.42,10.42,0,0,1-.29,2.22,6.92,6.92,0,0,1-.62,1.64,6.28,6.28,0,0,1-1,1.38,7,7,0,0,1-1.54,1.27c-.88.56-1.14.73-3.37,2s-2.48,1.42-3.36,1.88a3.77,3.77,0,0,1-1.54.51,1.34,1.34,0,0,1-1-.28,1.79,1.79,0,0,1-.62-.92,5.91,5.91,0,0,1-.29-1.89c0-1.15-.05-1.5-.05-4.46s0-3.32.05-4.51a10,10,0,0,1,.29-2.23,7,7,0,0,1,.62-1.63,5.84,5.84,0,0,1,1-1.38,7.23,7.23,0,0,1,1.54-1.28c.88-.56,1.14-.72,3.36-2m0-2c-2.26,1.3-2.54,1.48-3.43,2.05a9.61,9.61,0,0,0-2,1.68,9.94,9.94,0,0,0-1.47,2.13,10.9,10.9,0,0,0-1,2.52,13.06,13.06,0,0,0-.39,2.91c0,1.21-.05,1.59-.05,4.61s0,3.38.05,4.54a7.9,7.9,0,0,0,.39,2.47,2.81,2.81,0,0,0,1,1.41,2,2,0,0,0,1.47.43,4.89,4.89,0,0,0,2-.65c.89-.46,1.17-.61,3.43-1.91s2.55-1.48,3.43-2.05a9.12,9.12,0,0,0,2-1.68,9.61,9.61,0,0,0,1.48-2.13,11.08,11.08,0,0,0,1-2.52,13.84,13.84,0,0,0,.38-2.92c0-1.2.06-1.59.06-4.6s0-3.39-.06-4.55a8.39,8.39,0,0,0-.38-2.47,2.86,2.86,0,0,0-1-1.41,2.1,2.1,0,0,0-1.48-.43,5.2,5.2,0,0,0-2,.66c-.88.45-1.17.6-3.43,1.91",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,364.1c-2.36,1.36-4.27,5-4.27,8.16s1.91,4.59,4.27,3.23,4.28-5,4.28-8.16-1.92-4.6-4.28-3.23m0,9.39c-1.53.89-2.77-.05-2.77-2.09a6.63,6.63,0,0,1,2.77-5.3c1.54-.89,2.78,0,2.78,2.09a6.62,6.62,0,0,1-2.78,5.3",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.52,362c0,.74.45,1.07,1,.76a2.41,2.41,0,0,0,1-1.91c0-.74-.45-1.07-1-.76a2.41,2.41,0,0,0-1,1.91",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mobile--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.41,279.6,121.27,381.3c-4.53,2.61-4.48,5.59-4.48,8.25a9.63,9.63,0,0,0,4.48,8.26l84,48.49a13.15,13.15,0,0,0,11.88,0L393.28,344.6c3.28-1.89,4-5.07,4-7.73s-.74-6.88-4-8.78l-84-48.49A11.2,11.2,0,0,0,297.41,279.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.75,283.27l86.36,49.86L211.2,435.24v12.48a12.22,12.22,0,0,0,5.94-1.42L393.28,344.6c3.28-1.89,4-5.07,4-7.73s-.74-6.88-4-8.78l-84-48.49a11.32,11.32,0,0,0-7.54-1.58v5.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.8,387.45,207,436.08a9.23,9.23,0,0,0,8.33,0L390.07,335.22c3.52-2,3.52-5.37,0-7.4l-82-47.34a10.48,10.48,0,0,0-9.45,0L122.8,382C120.2,383.5,120.2,386,122.8,387.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.05,360.9a5,5,0,0,0-2.34,3.88,1.45,1.45,0,0,0,.64,1.37c.28.15,1.35.79,1.64,1a1.72,1.72,0,0,0,1.69-.19l29.55-17.08a5,5,0,0,0,2.34-3.89,1.48,1.48,0,0,0-.6-1.33l-1.68-1a1.75,1.75,0,0,0-1.7.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.68,361.84l29.55-17.08c1.29-.75,2.34-.22,2.34,1.18a5,5,0,0,1-2.34,3.89l-29.55,17.08c-1.3.75-2.34.22-2.34-1.18A5,5,0,0,1,351.68,361.84Z",
    style: {
      fill: "#37474f"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M294.77,286.44l-163.9,94.63c-2.48,1.44-2.49,3.77,0,5.2l76.21,44a9.91,9.91,0,0,0,9,0L381.17,335c2-1.16,2.41-2.92,1.14-4.31l-.31-.31a5.29,5.29,0,0,0-.83-.58l-21.43-12.38-1.4-.8a3.05,3.05,0,0,0-2.79,0,3.2,3.2,0,0,1-2.89-.06l-25-14.42c-.82-.47-.87-1.22-.1-1.67s.77-1.08.14-1.53l-.13-.08-21-12.11-.44-.26A12.65,12.65,0,0,0,294.77,286.44Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M355.55,319.77a3.08,3.08,0,0,1,2.79,0l1.4.81L381.17,333a6.05,6.05,0,0,1,.83.58l.31.32a1,1,0,0,1,.08.11,4.46,4.46,0,0,1-1.22,1l-165.1,95.32a9.91,9.91,0,0,1-9,0l-76.21-44a4.58,4.58,0,0,1-1.22-1,4.72,4.72,0,0,1,1.23-1l163.9-94.62a12.65,12.65,0,0,1,11.4,0l.44.26L327,301.69v2.72a1.09,1.09,0,0,0,.65.88l25,14.43A3.17,3.17,0,0,0,355.55,319.77Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.55,319.77a3.08,3.08,0,0,1,2.79,0l1.4.81L381.17,333a6.05,6.05,0,0,1,.83.58l.31.32a1,1,0,0,1,.08.11,4.46,4.46,0,0,1-1.22,1l-165.1,95.32a9.91,9.91,0,0,1-9,0l-76.21-44a4.58,4.58,0,0,1-1.22-1,4.72,4.72,0,0,1,1.23-1l163.9-94.62a12.65,12.65,0,0,1,11.4,0l.44.26L327,301.69v2.72a1.09,1.09,0,0,0,.65.88l25,14.43A3.17,3.17,0,0,0,355.55,319.77Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.57,311.61,342.11,305a2.62,2.62,0,0,0-2.39-.05c-.64.37-.61,1,.07,1.39L351.24,313a2.67,2.67,0,0,0,2.4,0C354.28,312.62,354.25,312,353.57,311.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.71,301.33a3.11,3.11,0,0,0-2.79,0,.85.85,0,0,0,0,1.61,3.05,3.05,0,0,0,2.79,0A.85.85,0,0,0,336.71,301.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.35000000000000003
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "225.59 326.38 247.09 313.97 266.1 401.39 244.6 413.8 225.59 326.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.66,390.1l-19-87.42,28.13-16.24a12.65,12.65,0,0,1,11.4,0l.44.26L319.25,294l14.82,68.15Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Leg--inject-68"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M414.7,288.72a3.49,3.49,0,0,0,1.52,2.92,16.41,16.41,0,0,0,12.14,1c4.57-1.42,6.64-3.8,7.53-6.93a18.2,18.2,0,0,0,0-10.78c-.83-2.71-.34-6.38,0-9.13.58-4.68-.37-7.49-1.88-9.64a6.62,6.62,0,0,0-7.53-2.51l.9,32.12Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M420.34,274.46c0,4.22-.94,5.74-2.79,8.24-1.62,2.19-5.83,5.65-.44,8.31,4.21,2.07,14.65,1.84,17.44-5.12,2.17-5.4-1.09-10.46-.29-17.54.54-4.75.12-13.05-5.4-14.32-3-.69-4-.64-8.72,1.78-3.29,1.68-3.56,2.44-3.43,2.88l.8-.37a6,6,0,0,1,6.28,2.69c1.91,3,2.14,7.39.09,10.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.84,282.29c4.12-3.17,13.71-1.32,15.56,1.28s1.22,3.93,0,5.2-5.43,4.34-12.25,3.61-6.93-3.27-7-4.31S416,284.09,417.84,282.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.64,260.63c-2.63-4.76-6.19-4.44-6.19-4.44L401.23,265s37.83-34.74,36.62-39.75l-51.71-2.38s-23.3,44.2-26,59.07c-1.61,8.76-.72,14.88,3.41,18.18,7,5.59,15.11,3.19,27.93-4.52,13-7.81,33.42-19.88,33.42-19.88S428.8,268.14,424.64,260.63Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.64,260.63c-2.63-4.76-6.19-4.44-6.19-4.44L401.23,265s37.83-34.74,36.62-39.75l-51.71-2.38s-23.3,44.2-26,59.07c-1.61,8.76-.72,14.88,3.41,18.18,7,5.59,15.11,3.19,27.93-4.52,13-7.81,33.42-19.88,33.42-19.88S428.8,268.14,424.64,260.63Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.33,262c-.2-.46-.43-.93-.69-1.4a9.11,9.11,0,0,0-.5-.83,2.43,2.43,0,0,0-.14-.2l-.37-.53a1.07,1.07,0,0,1-.14-.16l-.39-.46-.13-.12-.4-.4-.1-.09-.42-.35-.09-.06c-.14-.11-.29-.21-.43-.3l-.07,0-.42-.24-.06,0-.41-.2h-.05l-.4-.15h0l-.37-.11h0l-.34-.07h0l-.29-.05h0l-.23,0h-.35L416,257.45,401.23,265h0s3.18-5.73,5.89-11.77v0h0l.33-.74v-.05c.1-.24.21-.47.31-.71v0c.49-1.12.94-2.24,1.35-3.32l0-.06c.13-.35.26-.7.38-1L389,234.36c1.34,7.74,8.76,18.38,8.76,18.38s-11.91,25.11-16.17,36.18c-3.34,8.69-9.88,11.27-15.42,9.92a8.58,8.58,0,0,1-6.41-5.49,10.94,10.94,0,0,0,3.79,6.73c7,5.59,15.11,3.19,27.93-4.52,13-7.81,33.41-19.87,33.42-19.87h0a17.42,17.42,0,0,0,.73-12.95C425.53,262.5,425.43,262.27,425.33,262Z",
    style: {
      fill: "#FB923C",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.43,275.58c5.1-6.53,19.19-15.46,22.29-17.5a5.91,5.91,0,0,0-4.26-1.89h0l-8.61,4.38L401.23,265s-8.32,18-15.09,20.74A32.05,32.05,0,0,0,400.43,275.58Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Le--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.88,302.2a3.45,3.45,0,0,0,1.37,3,17.3,17.3,0,0,0,12.49,1.13c4.57-1.41,6.77-4,7.66-7.12s.58-6-.34-10.25a30.55,30.55,0,0,1,0-9.5c.58-4.68-.41-7.65-1.93-9.8a6.6,6.6,0,0,0-7.53-2.52l.91,32.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.51,288c0,4.21-.94,5.73-2.78,8.23-1.62,2.2-5.84,5.66-.44,8.31,4.21,2.07,14.65,1.85,17.44-5.11,2.17-5.4-1.1-10.46-.29-17.55.54-4.75.12-13.05-5.4-14.32-3-.69-4-.63-8.72,1.78-3.29,1.69-3.56,2.44-3.43,2.88l.8-.36A6,6,0,0,1,446,274.5c1.9,3,2.14,7.38.09,10.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.1,295.54c4.13-3.17,13.72-1.33,15.56,1.27s1.22,3.93,0,5.2-5.43,4.35-12.24,3.62-6.94-3.27-7.05-4.31S438.3,297.34,440.1,295.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442,292.12c2.62-1.5,8.75-1.17,10.43,0,0-1.26-1.58-2.15-5.09-2.15S442,291,442,292.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.51,288.72c2.61-1.49,8.74-1.17,10.42,0,0-1.26-1.57-2.15-5.08-2.15S442.51,287.62,442.51,288.72Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.69,271.81l-13.39,5.66,7.33,18.07,8.88-7.59,3.55-3.17s3.12-2.78,1.56-7.86S443.58,270.52,439.69,271.81Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.14,280.7a12.67,12.67,0,0,0-5.53-6.28l-4.56,2.3s7-10.7,9.83-18c3.38-8.63,6.34-19.47,0-33.51l-33.4,5.62-19.12-6.44c3,14.49,16.69,27.38,16.69,27.38S387,283.29,384.68,293c-2.2,9.17-.64,16.08,3.5,19.38,7,5.59,16.74,5.7,28.91-3A237.25,237.25,0,0,0,440,290.17S440.76,287.17,438.14,280.7Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.14,280.7a12.67,12.67,0,0,0-5.53-6.28l-4.56,2.3s7-10.7,9.83-18c3.38-8.63,6.34-19.47,0-33.51l-33.4,5.62-19.12-6.44c3,14.49,16.69,27.38,16.69,27.38S387,283.29,384.68,293c-2.2,9.17-.64,16.08,3.5,19.38,7,5.59,16.74,5.7,28.91-3A237.25,237.25,0,0,0,440,290.17S440.76,287.17,438.14,280.7Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.61,274.42l-4.56,2.3h0s-10.5,18.57-17.27,21.31a29.09,29.09,0,0,0,14.29-10.13C428.76,282.84,432.61,274.42,432.61,274.42Z",
    style: {
      fill: "#FB923C",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.9,255.1,374.32,266c-1.49,3.64-3,7.28-4.27,11-.68,1.84-1.29,3.7-1.88,5.56-.28.94-.58,1.87-.84,2.81l-.38,1.42c-.12.47-.26.94-.36,1.42a42.09,42.09,0,0,0-1.4,11.62l-.23-1.46c0-.25-.07-.5-.09-.74l0-.74-.06-1.5.05-1.49a43.37,43.37,0,0,1,.73-5.91,77.79,77.79,0,0,1,3.22-11.45c1.36-3.72,2.89-7.38,4.59-10.94S376.88,258.49,378.9,255.1Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.75,267.61l-4.58,10.9c-1.5,3.64-3,7.28-4.27,11-.68,1.84-1.3,3.7-1.88,5.57-.28.94-.59,1.87-.84,2.81l-.38,1.42c-.13.47-.27.94-.37,1.42a42.86,42.86,0,0,0-1.4,11.62l-.22-1.47c0-.24-.07-.49-.1-.73l0-.75-.06-1.49.05-1.49a41.85,41.85,0,0,1,.73-5.91A77.79,77.79,0,0,1,393.62,289q2-5.59,4.58-10.95C399.9,274.51,401.73,271,403.75,267.61Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.33,228.57a17.71,17.71,0,0,1,2.52,5.93,34.65,34.65,0,0,1,.92,6.4c.05,1.07.07,2.15.05,3.22s-.07,2.15-.19,3.21a30.78,30.78,0,0,1-1.19,6.32q.12-3.21.14-6.37c0-.53,0-1.05,0-1.58s0-1,0-1.58c0-1.05-.05-2.1-.12-3.15q-.15-3.15-.6-6.26A32.33,32.33,0,0,0,424.33,228.57Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.35,230a6.87,6.87,0,0,1,1.39,1.83c.18.34.34.69.51,1s.3.7.44,1.06a27.68,27.68,0,0,1,1.24,4.38,26.37,26.37,0,0,1,.48,4.53,12.54,12.54,0,0,1-.63,4.51,38,38,0,0,0-.42-4.43c-.06-.36-.12-.73-.17-1.09s-.13-.73-.19-1.09c-.12-.73-.24-1.45-.4-2.17s-.29-1.45-.44-2.17l-.23-1.08c-.09-.36-.17-.72-.25-1.08A21.39,21.39,0,0,0,429.35,230Z",
    style: {
      fill: "#FB923C"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.87,161.54c-6.89-1.2-9.37,1.51-21.1,11.28-10.83,9-16.67,14.16-16.67,14.16S344.23,174,342.74,172.27s-1.34-6-2.91-9-3.14-5.13-4.35-7.21-3.9-.05-2.66,3.4,1.72,5.34,1.12,5.38-6.44-5.22-7.12-9.31-1.84-3.22-2.87-3.49c0,0-.43-2.57-2.5-2.14-.59.12-.85.43-1.15,2.94a2.53,2.53,0,0,0-2.5,2.07,14.94,14.94,0,0,0-.16,5s-1.35,1.4-.07,5.46,5.6,8.47,11.23,12.3,7,5.86,13.32,12.23a185.58,185.58,0,0,0,14.7,13.71c5.61,4.39,8.83,1.92,13.42-1.45,6.62-4.86,19.44-16,19.44-16Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,160.14A15.09,15.09,0,0,0,386.58,164c-6.15,5-24.21,22.74-24.21,22.74A17.69,17.69,0,0,1,369,192.3c3.18,4.84,3,8.73,3,8.73l16.23-13Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,186.91c1.73.53,6,4.12,7.82,7.54a17.15,17.15,0,0,1,1.86,6.9l4.9-3.74s.62-2.62-2.1-7.65-9.05-6.24-9.05-6.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.05,201.22c-8.19-6.62-6.83-16-5.39-19.84,2.89-7.72,15.37-21.24,15.37-21.24a84.36,84.36,0,0,1,17.58-.47c8.42.67,18,4.91,18,4.91-1.77,3.91-5.37,9.18-4.57,13.77,1.92,10.93,11,17.8,11,17.8s-1.75,9.33-2.11,12.16c-.25,1.92-.42,6.64,1,10,2.72,6.52,3.53,13.36,4,15.43a2.23,2.23,0,0,1-1.19,2.5c-19,9.18-49.28,5.36-57.59-8.83,1.1-4.5,3.16-9.46,4-13.76S387.89,208,387.05,201.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.67,178a65.48,65.48,0,0,0-2.89,14.47,47.46,47.46,0,0,0,0,7.35c.11,1.22.31,2.4.46,3.67s.17,2.49.19,3.74c0,5-.24,9.91-.66,14.84-.23,2.47-.47,4.93-.84,7.39-.23,1.24-.55,2.41-.68,3.64a6.06,6.06,0,0,0,.33,3.6,6.14,6.14,0,0,1-.54-3.62c.06-1.24.32-2.48.47-3.68.28-2.45.45-4.91.6-7.38.28-4.92.55-9.86.46-14.78,0-1.23-.06-2.46-.15-3.67s-.33-2.45-.42-3.69a40.52,40.52,0,0,1,.13-7.47A55.79,55.79,0,0,1,399.67,178Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,160.14s-3.92,4.25-7.87,9.33c10,1.84,26.78,4.76,38.73,6.84,0-4.39,3.19-8.37,4.71-11.73,0,0-9.57-4.24-18-4.91A84.36,84.36,0,0,0,397,160.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.08,203.51s4.88,4.77,13.8,2.13,9.87-9.73,9.87-9.73,1.63,8.78-9,11.89C404.2,210.87,400.08,203.51,400.08,203.51Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.56,119.27a8.51,8.51,0,0,1-.1-1.33,4.71,4.71,0,0,1,3.3-4.32c2-.57,4.29.17,6-1a11.27,11.27,0,0,0,2.31-2.76,7.79,7.79,0,0,1,9.45-2c1.47.78,2.74,2.07,4.39,2.26s2.86-.7,4.35-.86a9,9,0,0,1,7,2.25,8.47,8.47,0,0,1,2.68,6.8,6.31,6.31,0,0,1,4.05,2.18c1.39,1.69,1.29,4.11,1.52,6.28a7.38,7.38,0,0,0,1.52,4.09c1,1.14,2.16,1.51,2.95,2.94a5.35,5.35,0,0,1,.68,4.29c-.5,1.36-1.81,2.21-2.81,3.26s-1.7,2.75-.81,3.89,2.51.89,3.85.61a3.4,3.4,0,0,1-2.41,2.73,9.43,9.43,0,0,1-3.82.22A5.44,5.44,0,0,1,431,153.2c-2.12,1.12-4.11-.29-6.12,1a17.16,17.16,0,0,1-2.17,1.51c-1.58.74-3.45.23-5.05-.46a16,16,0,0,0-3.77-1.4c-1.25-.2-1.62.6-2.65,1.22-1.89,1.14-4.39.78-6.36-.24a14.58,14.58,0,0,0-3.6-1.74c-1.44-.31-2.92.12-4.39.17a8.71,8.71,0,0,1-6.58-2.85,4.38,4.38,0,0,1-1.29-3c0-.54.36-3.66,1.11-3.73a3.83,3.83,0,0,0-2.86,1.77,3.89,3.89,0,0,1,.77-3.4,6.45,6.45,0,0,1,3-2,17.19,17.19,0,0,0,2.12-.75,2.71,2.71,0,0,0,1.49-1.59,2.57,2.57,0,0,0-.5-2.11c-1.24-1.69-3.49-2.29-4.38-4.28a5.49,5.49,0,0,1,.07-4.59,3.55,3.55,0,0,1-4.29-4,2.63,2.63,0,0,0,3.93-1.06A4.94,4.94,0,0,0,389.56,119.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.56,119.27a8.51,8.51,0,0,1-.1-1.33,4.71,4.71,0,0,1,3.3-4.32c2-.57,4.29.17,6-1a11.27,11.27,0,0,0,2.31-2.76,7.79,7.79,0,0,1,9.45-2c1.47.78,2.74,2.07,4.39,2.26s2.86-.7,4.35-.86a9,9,0,0,1,7,2.25,8.47,8.47,0,0,1,2.68,6.8,6.31,6.31,0,0,1,4.05,2.18c1.39,1.69,1.29,4.11,1.52,6.28a7.38,7.38,0,0,0,1.52,4.09c1,1.14,2.16,1.51,2.95,2.94a5.35,5.35,0,0,1,.68,4.29c-.5,1.36-1.81,2.21-2.81,3.26s-1.7,2.75-.81,3.89,2.51.89,3.85.61a3.4,3.4,0,0,1-2.41,2.73,9.43,9.43,0,0,1-3.82.22A5.44,5.44,0,0,1,431,153.2c-2.12,1.12-4.11-.29-6.12,1a17.16,17.16,0,0,1-2.17,1.51c-1.58.74-3.45.23-5.05-.46a16,16,0,0,0-3.77-1.4c-1.25-.2-1.62.6-2.65,1.22-1.89,1.14-4.39.78-6.36-.24a14.58,14.58,0,0,0-3.6-1.74c-1.44-.31-2.92.12-4.39.17a8.71,8.71,0,0,1-6.58-2.85,4.38,4.38,0,0,1-1.29-3c0-.54.36-3.66,1.11-3.73a3.83,3.83,0,0,0-2.86,1.77,3.89,3.89,0,0,1,.77-3.4,6.45,6.45,0,0,1,3-2,17.19,17.19,0,0,0,2.12-.75,2.71,2.71,0,0,0,1.49-1.59,2.57,2.57,0,0,0-.5-2.11c-1.24-1.69-3.49-2.29-4.38-4.28a5.49,5.49,0,0,1,.07-4.59,3.55,3.55,0,0,1-4.29-4,2.63,2.63,0,0,0,3.93-1.06A4.94,4.94,0,0,0,389.56,119.27Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.22,126.94a23,23,0,0,0-.92,4,52.85,52.85,0,0,0-1,8.21c-.14,11.36,3.08,13.26,5.47,14.75,1.5.93,2.86,1.35,6.41,1.51l-.3,5.88s-4.69,4.86-4,14.65a23.18,23.18,0,0,0,8.23-6.09c8.11-3.91,13.46-6.45,13.46-6.45l.28-13.86s2.86,2.74,6.6-.34c2.9-2.4,3.79-7.67,1.4-10s-5.52-1.91-7.42,1.58c-1.36,2.48-3.12.27-2.39-2.49s-2.3-4.11-3.11-5.64c-2.61-4.92,1.09-5.4-2.27-9.05-1.86-2-5.81-3-9.79-.64C402.73,120,397.57,118,394.22,126.94Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.74,144.25l-6.16,1A3,3,0,0,0,405,148,3.38,3.38,0,0,0,407.74,144.25Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.33,146.32A3.22,3.22,0,0,1,405,148a2.88,2.88,0,0,1-1.84-.32,2.6,2.6,0,0,1,2.92-1.93A2.56,2.56,0,0,1,407.33,146.32Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.61,134.78a1.63,1.63,0,1,0,1.75-1.58A1.68,1.68,0,0,0,407.61,134.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.88,133.18a1.64,1.64,0,0,0,1.49,1.78,1.68,1.68,0,1,0-1.49-1.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.9,129.37l3.61,2.45a2.38,2.38,0,0,0-.63-3.19A2.08,2.08,0,0,0,408.9,129.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.58,129.62l4.11-1.35a2,2,0,0,0-2.61-1.5A2.39,2.39,0,0,0,395.58,129.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.56 131.86 402.32 142.15 397.09 139.44 404.56 131.86",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.21,155.45c7,0,13.21-2.74,15.3-6.73a8.67,8.67,0,0,1-4.14,6.25c-4.36,2.8-11.27,2.7-11.27,2.7Z",
    style: {
      fill: "#af6152"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M400,176s2.52-1,6.72-6.58c2-2.73,5.53-4.19,9.19-6.35a29.31,29.31,0,0,0,5.88-4.55l0-2.17a3.71,3.71,0,0,1,1.84,2.58,31.1,31.1,0,0,0,2.6,5.43c-2.15,5.54-13,9.52-15.33,12.14a8.61,8.61,0,0,1-4-4.95S403.13,175.45,400,176Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.18,156l-.27,5.33a34.08,34.08,0,0,0-3.15,7.22A29.55,29.55,0,0,0,400,176a36.12,36.12,0,0,1-1.34-6.08c0-1.7-3.95.24-3.95.24a23.2,23.2,0,0,1,2.53-6.69,24.9,24.9,0,0,1,4-5.46,8.52,8.52,0,0,1,3-2Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M432.39,165.88c10.79,4.7,12.4,11.46,9.55,21.83-2.28,8.29-13.84,28.89-16.25,32.75-3.18,5.11-4.63,5.38-11.48,5.88s-29.93,2.85-29.93,2.85l-3.71-12.78,30.68-6,13.35-30S429.67,167.92,432.39,165.88Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.6,164.58c3.55,1.54,6.92,3.37,9.34,6.58s2.42,9.71.34,17.08-14.45,29.63-14.45,29.63-10.6-1.09-16.31-9.56l13.71-31.11S427.79,168.12,432.6,164.58Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.84,205.31a16.26,16.26,0,0,0,7.55,7.54c5.64,2.83,9,2.92,9,2.92l-3,4.38a22.93,22.93,0,0,1-9.3-3,20.35,20.35,0,0,1-6.78-6.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.07,215.4c-2.11.16-4.27-.93-6.31-1.23a29.84,29.84,0,0,0-5.43-.08c-1.88,0-3.77.16-5.66.21-.47,0-.61.47-.58.89a2.68,2.68,0,0,0,1.21,1.95,6.15,6.15,0,0,0,2.2.85,16.35,16.35,0,0,0,2.1.31c.73.06,2.49.19,2.24,1.3Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.07,215.4a11.12,11.12,0,0,1-4.36-.54,20.25,20.25,0,0,0-2.11-.43,17.16,17.16,0,0,0-2.16-.12c-1.44,0-2.91.06-4.37.06s-2.93,0-4.4-.07c1.46-.18,2.92-.3,4.38-.4s2.92-.19,4.4-.2a16.87,16.87,0,0,1,2.23.17,14.24,14.24,0,0,1,2.16.55c.69.23,1.38.46,2.08.64A8.25,8.25,0,0,0,384.07,215.4Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.89,214.18s-4.89,1-7.82,1.22l-10.23,4.2c-.19.8-1.53,1.6-2.14,2.08-3.37,2.67-8.24,2.14-10.56,2.71s-2.49,1.46-1.77,2.3,5,1.21,7.08,1.09a39.66,39.66,0,0,0,5-.76s-2.83,2.53-5.47,3-5.35-.26-6.65,1.17c-.77.85.55,1.46,1.2,1.7a15.12,15.12,0,0,0,1.83.39,1.29,1.29,0,0,0,.13,1.21,3,3,0,0,0,1,.59,11.94,11.94,0,0,0,5.51,0c-1.17.52-1.94.57-2.48,1.14a1,1,0,0,0-.15,1.19c.23.46,1.14.37,1.66.34a20.39,20.39,0,0,0,7.91-1.89,17.65,17.65,0,0,0,3.14-1.95c.79-.56,1.34-1.71,2.48-2.63a9.85,9.85,0,0,1,4.12-2.26c3.35-.48,7.43-.75,7.43-.75S396.28,221,391.89,214.18Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.4,233.26a33.47,33.47,0,0,0,6.58-.54,12.33,12.33,0,0,0,3-1.22l3-1.49a26.86,26.86,0,0,1-2.81,1.81,11.34,11.34,0,0,1-3.1,1.31A20.82,20.82,0,0,1,362.4,233.26Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,235.11a22.14,22.14,0,0,0,3.25-1.21c1.06-.46,2.07-1,3.15-1.51a13.17,13.17,0,0,1-3,1.9A8.51,8.51,0,0,1,369,235.11Z",
    style: {
      fill: "#af6152"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.35,170.12l-32.46,5.6,7,57.23s-7.93,7.78-12.46,16.72c-3.28,6.49-13.42,32-15.27,36.07a51.83,51.83,0,0,1-3.38,6.09c-.7,1.11-1.73,1.67-2,2.95-1.1,5.66,2.11,12.87,5.67,17.41a12.15,12.15,0,0,0,3.43,3.12,6.8,6.8,0,0,0,4.48.93,2.87,2.87,0,0,0,2.26-1.48,3.59,3.59,0,0,0,.08-2.08A69.3,69.3,0,0,1,86.6,305a22.3,22.3,0,0,1,5.13-14.82c4.42-5.62,33.77-45,35.39-47.66,2.43-4,5.16-7.42,5.43-20.66C132.82,208.43,131.69,176.89,130.35,170.12Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.85,173.17s.58,10,.07,30.91c-.42,17.46,1.52,29.18-5.49,40.29-6.26,9.92-33.26,44.55-36.08,48,0,0-9.4-.74-14-8.54,0,0,5.17-14.07,10.6-25.73l10.74-23L86,181.14Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.89,286.59l-.91-.3c3.84-11.51,19.4-44.11,25.93-50.3l.67.7C100.27,242.66,84.61,275.45,80.89,286.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.93,277c1.65,3.63,10.94,10.93,15.59,10.06l-5.22,6.77c-4.28.22-11.09-4.38-13.51-9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.86,177.78,86,181.14,98.68,235l-7.93,17c.32,1,1.25,7,1.34,7.33.31,1.2-2.69,6.1-.72,20.86.38,2.84,1.39,6.95,2,9.59,5.16-6.58,16.17-20.57,24.38-31.82.58-1,1.52-2.71,1.52-2.71s1.82-9.5,1-16.41c-.68-5.83-3.24-36.17-3.24-36.17s3.07-1.07,6.49-5.37a15.26,15.26,0,0,0,2.62-5S128.92,182.68,129.86,177.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9,299.28c-.71-.11-1.19,2.43-1.23,3.25s.76,2.38,1.79,4.06,2.79,3.81,3.66,6.5.95,7.43,3.3,10.9,8,7,15.14,6.44c2.19-.17,4.76-1.43,5.31-2.16a3.4,3.4,0,0,0,.8-2.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,314.5a18.91,18.91,0,0,0-3.2-6.89c-1.7-2.65-3.62-4.4-3.61-7.62a10.75,10.75,0,0,1,3.53-5.33c2-1.86,2.28-4,3.56-3.71,0,0-.46.75-.47.75.52,1.06,2,2,2.51,2.69a2.66,2.66,0,0,1,.65,2.2,7.46,7.46,0,0,0,.63,3.88,12.59,12.59,0,0,1,.54-2.45,2.47,2.47,0,0,1,1.5-1.65c1.37-.65,3.45.06,4.53.44,1.64.58,3.56,1,4.37,2.23.69,1-.19,2.67-.57,3.67-1,2.76.19,5.77,1.25,8.3,1.15,2.72,3,6.54,5,8.66s3.59,3.12,2.39,5.95a5,5,0,0,1-2,2.14,7.51,7.51,0,0,1-2.77,1,16.2,16.2,0,0,1-11.53-2.32,13.38,13.38,0,0,1-3.88-4.31C75.24,320.18,74.75,317.76,74,314.5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.24,317.77c3.34-2.5,8.65-3,10.18-2.23a3.1,3.1,0,0,1,.77,1.32c-1.29-1.14-6.13-.93-10.39,1.84A.88.88,0,0,1,81.24,317.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.27,313.42c4.37-2.72,8.93-2.3,10.41-1.43a1.62,1.62,0,0,1,.51,1.13c-1.6-1.1-6.45-1.09-10.42,1.27A.89.89,0,0,1,79.27,313.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.76,308.73c5.26-2.19,8.92-1.7,10.35-.74a1.49,1.49,0,0,1,.37,1.1c-1.54-1.18-5.65-1.35-10.44.74A.85.85,0,0,1,77.76,308.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.53,304.23c4.28-2.15,8.83-1.26,10.13-.14.13.12.08.77,0,1.16-1.38-1.36-6.12-1.87-10.07.14C77.16,304.94,77.53,304.23,77.53,304.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.54,324.25c-.32-5.14-.35-9.9-.34-15q0-10.41.09-20.81l.15-21.32q.07-8.5.14-17c-1.62-23.61-6.91-50.56-6.91-50.56a33.12,33.12,0,0,0,10.55-8.62c7.67-9.13,8.25-17.34,8.25-17.34l-3.89-.63L83,170.83c-.51,7-1.66,16.83-1.53,26,.29,18.8,15.38,56,15.38,56-.41,2.56-3.24,13.28-1.48,23,2.77,15.39,5.1,32.06,6.06,40.4s2,13,1.7,14.63c-.22,1.2-.91,3.13-.42,4,.67,1.19,1.71,1.71,3.19,3.36,1.85,2.07,2.5,3.34,4.6,5.2a17,17,0,0,0,5.79,3.24c2.58.9,5.61,1.55,8.24.77.92-.27,3-.91,3.14-1.87a3.06,3.06,0,0,0-.76-2.05c-2.74-4-3.09-4.34-5.74-8.37C117.77,330,117.77,328.06,117.54,324.25Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.07,168.9c-.3,8-.42,13.45-.33,19.24.11,7.23,1.75,14.49,3.69,22.7s11.38,44.79,12.12,47.69c-1,6.28-2.12,11.82,0,25.51,3,19.74,6.71,37.18,6.71,37.18s10.13,2.68,16.42-1.05c0,0,2.12-56.34,1.73-69.26-.33-11.22-5.13-49.53-5.13-49.53A24.16,24.16,0,0,0,126,193.94c3.69-4.24,5.47-12.14,6.09-20.53Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.52,254.56c-.52-2.25-2-7.81-4-14.84-3.24-11.82-7.67-30.64-9.14-37.85C84.65,193.28,85,175.38,85,175.2l-1,0c0,.18-.35,18.19,1.44,26.88C87,209.3,91.2,227.49,94.62,240c1.85,6.75,3.45,12.58,4,14.8.59,2.52.35,4.83,0,8a81,81,0,0,0,.17,20.39c1.19,9.56,4.58,28.43,6.48,38.74l1,.1c-1.89-10.24-5.33-29.34-6.52-39a79.26,79.26,0,0,1-.17-20.17C99.88,259.73,100.14,257.23,99.52,254.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.58,312.91c3.63,1.92,15.16,2.53,18.4-1.11l-.23,8.57c-3.34,2.88-11.8,3.21-16.68,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.49,341.07a4.19,4.19,0,0,0,0,2.85c.37.86,1.59,1.81,3.49,3s3.8,1.79,5.53,4.52c1.23,1.94,3.6,6.2,7.73,8.6s9.7,3.68,14.88,1.94,5.68-4,5.6-6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.11,333.42a5.67,5.67,0,0,0,1.1,2.59c1.53,2.68,4.15,5.14,6.32,7.34a70.18,70.18,0,0,0,7.39,6.36c2.13,1.62,3.53,3.33,3.43,4.79-.33,4.55-5.77,6.64-11.36,6.56a17.49,17.49,0,0,1-9.37-2.86,18.67,18.67,0,0,1-4.26-4.26c-2.49-3.43-3-5.22-5.94-7-2.53-1.54-4.56-1.7-7-5.43-.93-2.52.23-5.23.59-7.78a26.78,26.78,0,0,0,0-3.47,1.48,1.48,0,0,1,1.12-1.43c0,.23.08,1.13.08,1.13a3.23,3.23,0,0,0,1.8,1.23c1.41.48,3.41-.12,3.68,1,.16.64.21,1.08.32,1.35a9.54,9.54,0,0,0,1.29,2.77s-.13-1.18-.12-1.95a5.34,5.34,0,0,1,.44-2.6c.43-1,1.51-1.22,2.42-1.61a13.24,13.24,0,0,1,5.2-1.25,2.58,2.58,0,0,1,2.5,1.27c.46.68.36,2.24.37,3.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.88,338.76c1.89-1.89,8.83-4.66,10.86-3.54,0,0,.51.14.59,1-1.8-.53-6.51.39-10.67,3.41A1.05,1.05,0,0,1,110.88,338.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.87,342.49c1.76-1.76,8-4.36,10.3-3.72.17,0,1,.78,1.06,1.19-1.81-.53-6.43.39-10.58,3.41A1.05,1.05,0,0,1,113.87,342.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.25,346.08c1.76-1.76,8.1-4.35,10.44-3.72.17,0,1,.78,1.05,1.19-1.81-.52-6.56.39-10.71,3.41A1.05,1.05,0,0,1,117.25,346.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.61,349.87c2.1-2.38,8.14-4.36,9.77-3.84.17.05,1.37.78,1.4,1.19-1.8-.7-6.65.47-10.39,3.53A1.06,1.06,0,0,1,121.61,349.87Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.06,107.94c7,.6,8.76,3.88,17.69,16.44C155,136,159.38,142.5,159.38,142.5s20.78-8,22.69-9.37,2.86-5.53,5.15-8,4.39-4.2,6.11-5.92,3.82,1,1.72,4-3.06,4.77-2.48,5,7.63-3.43,9.35-7.25,2.63-2.67,3.7-2.67c0,0,1.08-2.4,3-1.44.54.27.72.63.36,3.16a2.56,2.56,0,0,1,1.91,2.67,15.13,15.13,0,0,1-1.14,5s.95,1.72-1.34,5.34-7.64,6.83-14.13,9.12-8.33,3.93-16.16,8.5a187,187,0,0,1-17.88,9.61c-6.61,2.84-9.07.39-13-3.8-4.89-5.21-16.14-18.76-16.14-18.76Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.06,107.11c7.68,1.69,8,3.06,12.28,8.72s18,26.17,18,26.17l7.83-2.91s-2.83,2.6-.48,8.49,6,6.54,6,6.54-6.62,3.8-11.31,6-7.83,2.74-11.87-.89S130.68,138,130.68,138Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.57,140.43c.39-17.67-2.27-28.21-7.87-31.05-2.62-.77-10.24-3.79-17.42-3.43s-25.92,8-29.8,9.34A178.51,178.51,0,0,1,81,152.86c-.89,13.36-2.52,15.67-2.7,31.23,11.28,6,48,8.75,55.47-3.23C134,168.9,134.11,160.61,134.57,140.43Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.51,100.84c-.94-4.21-5.39-8.42-7.48-12s-3.25-6.18-3.21-9.55c0-2,1.13-4.75,2.58-5.39A9.24,9.24,0,0,1,98.59,62a32.52,32.52,0,0,0,4-1.34c1.57-.75,1.87-2.06,3.1-3.22,2.12-2,5.86-2.23,7.43.55,1.38-2,3.39-2,5.74-1.57a4,4,0,0,1,3.26,4.31c3-1.89,6,.15,6.34,2,.28,1.33.05,2.48,1,3.64s2.93,1.18,3.44.06c.42,1.89-.25,3.39-2.33,3.39a4.34,4.34,0,0,1,.73,3.61,4,4,0,0,1-3.44,2.91,6.78,6.78,0,0,1-.77,3,7,7,0,0,1-2.32,2.32c-3.06,1.65-6.5,2.31-9.84,3.19l-4,1c-.24.06-1.44.2-1.57.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.09,95.61a4.12,4.12,0,0,0,5-.4L101,108c2.25,6.12,9.65,10,14.88,9.44,6.08-.67,6.35-5,2-9.51l0-3.82a41.89,41.89,0,0,0,5-.5c3.3-.62,5.67-3.45,6.43-7.1a37.52,37.52,0,0,0-.32-14.31,12.38,12.38,0,0,1-.36-3.48,16.27,16.27,0,0,0-1.42-7.45c-3.81-2.76-12.33-3.33-20,1.87,1.15,4.66-.49,8.47-3.81,10.44.22,1.26.54,4.46-1.55,4.51-1.5,0-1.7-1.85-3.32-3.43s-5.26-1.85-6.53.67A8.14,8.14,0,0,0,95.09,95.61Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.84,104.1c-5.31-.35-9.44-.74-12.39-4.42a33.46,33.46,0,0,1-3.5-6.1,25.74,25.74,0,0,0,2.67,7.73c1.45,2.37,4.91,4.4,13.22,4.69Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.57,83.82a1.52,1.52,0,0,1-1.43,1.6,1.53,1.53,0,0,1-1.54-1.5,1.49,1.49,0,1,1,3-.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.92,79l-3.29,1.54a1.9,1.9,0,0,1,.91-2.48A1.78,1.78,0,0,1,113.92,79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.67,78.85l-3.57-.79a1.75,1.75,0,0,1,2.12-1.42A1.91,1.91,0,0,1,126.67,78.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.31,82.42a1.49,1.49,0,1,1-1.55-1.49A1.51,1.51,0,0,1,126.31,82.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.04 88.49 119.6 91.32 118.4 80.66 125.04 88.49",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.31,92.78l6.06,1.93a3.12,3.12,0,0,1-3.94,2.17A3.31,3.31,0,0,1,114.31,92.78Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,93.86a3.38,3.38,0,0,0-.77-.06,3.28,3.28,0,0,0,2.24,3.08,2.93,2.93,0,0,0,1,.13A2.92,2.92,0,0,0,115,93.86Z",
    style: {
      fill: "#f28f8f"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M100.77,105.29,101,108s1.76,10.83,1,29.31-1.56,53-1.18,58.17C92,195.88,81.23,191,77.34,186c0,0,1.8-20.33,2.91-33.37s-.77-40.67-.77-40.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.14,126.89l0-.13c.17-1.72.5-3.32.81-5s.7-3.25,1.06-4.87c.71-3.24,1.54-6.46,2.37-9.67l-1.8,9.79-.89,4.89c-.28,1.58-.58,3.19-.72,4.73l5.59,8.14.13.17-.07.2c-1.12,3.24-2.17,6.51-3.33,9.74,1.36,5.57,2.66,11.17,3.94,16.77Q96.9,153.35,94.66,145l0-.09,0-.09c1-3.25,2.06-6.46,3.09-9.69L92.23,127Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.84,104.9l0,3s7.73,2.79,9.91,18.5c1.49,10.72.7,62.7.7,62.7s4.68-.72,7-4.11c0,0,.75-35.81.75-46s.86-28.32-7.13-31.88A57.23,57.23,0,0,0,117.84,104.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.3,114.42c1.08,1.5,2.12,3,3,4.66s1.8,3.25,2.64,4.9l.07.14-.06.15-3.17,8.6,3.26,7.47,0,.1,0,.1q-1.51,8.67-3.23,17.29,1.16-8.67,2.51-17.3L130,133.05l-.06-.15.06-.16,3.23-8.58a76.42,76.42,0,0,0-5.37-9.45,30.54,30.54,0,0,0-7.52-8A28.6,28.6,0,0,1,128.3,114.42Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.35,175.52c2.08.52,4.41-.19,6.5-.14a30.14,30.14,0,0,1,5.41.84c1.87.38,3.73.81,5.6,1.18.47.09.52.57.42,1a2.68,2.68,0,0,1-1.53,1.73,6.22,6.22,0,0,1-2.34.47,17,17,0,0,1-2.14-.05c-.74-.06-2.51-.24-2.45.91Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.35,175.52a11.45,11.45,0,0,0,4.44.22,15.84,15.84,0,0,1,2.17-.07,17.56,17.56,0,0,1,2.17.24c1.43.24,2.89.57,4.35.81s2.91.5,4.38.68c-1.42-.43-2.86-.79-4.29-1.14s-2.87-.69-4.34-.95a16.81,16.81,0,0,0-2.25-.22,13.82,13.82,0,0,0-2.24.18c-.74.11-1.46.22-2.19.28A8.11,8.11,0,0,1,126.35,175.52Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.64,188.39c-2.21-1-7.14-1.27-10-4.5-.52-.58-1.72-1.61-1.77-2.44l-9.47-5.93c-4-.43-5.17-.56-12.45-3.78-6.29-2.78-19.35-9.67-19.35-9.67l-4.73-26.61c-.92-8.8-4.78-22.24-9.81-22.93-12.13,2.85-11.25,15.43-8.38,30,2.15,10.91,4,19.23,5.52,25.64s1.66,8.24,8.57,10.23c13,3.73,22,6.17,33,9.08,1.43.38,3.12,1,5.66,3.81,1,1.1,2.78,3.18,3.48,3.87a18,18,0,0,0,3.09,2.13,20.34,20.34,0,0,0,7.55,3.22c.5.13,1.4.37,1.71-.05a1.05,1.05,0,0,0,.05-1.21c-.45-.66-1.2-.84-2.28-1.55a12.13,12.13,0,0,0,5.49.89,2.81,2.81,0,0,0,1.1-.41,1.3,1.3,0,0,0,.34-1.19,15.93,15.93,0,0,0,1.89-.07c.69-.13,2.1-.5,1.48-1.48-1.05-1.65-3.87-1.39-6.42-2.3s-4.93-3.91-4.93-3.91a40.41,40.41,0,0,0,4.89,1.61c2.09.48,6.38.85,7.23.13S149.84,189.35,147.64,188.39Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.87,197a34.22,34.22,0,0,1-6.46-1.66,13.15,13.15,0,0,1-2.8-1.73l-2.71-2a28.27,28.27,0,0,0,2.48,2.28,11.4,11.4,0,0,0,2.87,1.83A21.23,21.23,0,0,0,144.87,197Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.94,197.71a23.19,23.19,0,0,1-3-1.77c-1-.63-1.88-1.38-2.88-2a13.57,13.57,0,0,0,2.63,2.39A8.82,8.82,0,0,0,137.94,197.71Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.75,111.54c-4.46,1.28-9.71,3.09-10.93,10.51s-.09,12.83,2.1,24,4.85,23.49,6,26.82,1.85,4.37,7,6,17.67,4.76,17.67,4.76-1.24-2.87,1.14-8.47,4-6.28,4-6.28l-12.6-7s-3.85-23-5.3-30.86S86.62,114.93,80.75,111.54Z",
    style: {
      fill: "#37474f"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--small-hashtags--inject-68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--hashtag-bubble--inject-68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.06,453.24l-3.21-6,2.58-7.45v-4.56l-7.9,4.56v4.56l3.4,5.88a.47.47,0,0,0,.23.21h0Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.06,453.24l-3.21-6,2.58-7.45v-4.56l-7.9,4.56v4.56l3.4,5.88a.47.47,0,0,0,.23.21h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.33,386.26a5.22,5.22,0,0,0-2.37-4.1L180,381a5.27,5.27,0,0,0-4.74,0L100.5,424a5.24,5.24,0,0,0-2.37,4.11v22.06a5.24,5.24,0,0,0,2.37,4.1l1.93,1.11a5.21,5.21,0,0,0,4.74,0l14.32-8.18,3.39,5.87a.51.51,0,0,0,.92-.09l3.58-10.34L182,412.42a5.22,5.22,0,0,0,2.37-4.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.66,381.37a3.89,3.89,0,0,1,1.92.45l1.93,1.11a4.38,4.38,0,0,1,1.93,3.33v22.06a4.4,4.4,0,0,1-1.92,3.33l-52.58,30.2-.29.17-.11.32-3.31,9.54-3-5.14-.44-.77-.77.44-14.33,8.19a4.32,4.32,0,0,1-3.84,0L101,453.49A4.39,4.39,0,0,1,99,450.16V428.1a4.36,4.36,0,0,1,1.92-3.33l74.79-42.95a3.89,3.89,0,0,1,1.92-.45m0-.89a4.94,4.94,0,0,0-2.37.56L100.5,424a5.24,5.24,0,0,0-2.37,4.11v22.06a5.24,5.24,0,0,0,2.37,4.1l1.93,1.11a5.21,5.21,0,0,0,4.74,0l14.32-8.19,3.39,5.88a.5.5,0,0,0,.44.25.51.51,0,0,0,.48-.34l3.58-10.34L182,412.42a5.22,5.22,0,0,0,2.37-4.1V386.26a5.22,5.22,0,0,0-2.37-4.1L180,381a4.91,4.91,0,0,0-2.37-.56Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.13,450.16a5.24,5.24,0,0,0,2.37,4.1l1.93,1.11a5.26,5.26,0,0,0,4.33.19c-1.11.43-2-.2-2-1.55V432.59a6.63,6.63,0,0,1,.38-3.15l-6.35-3.68a4.83,4.83,0,0,0-.7,2.34Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.13,450.16a5.24,5.24,0,0,0,2.37,4.1l1.93,1.11a5.26,5.26,0,0,0,4.33.19c-1.11.43-2-.2-2-1.55V432.59a6.63,6.63,0,0,1,.38-3.15l-6.35-3.68a4.83,4.83,0,0,0-.7,2.34Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.25,385.59c-.28-1-1.19-1.33-2.29-.7l-74.79,42.95a5,5,0,0,0-2,1.6l-6.35-3.67A4.77,4.77,0,0,1,100.5,424l74.79-43a5.27,5.27,0,0,1,4.74,0l1.93,1.12A5.21,5.21,0,0,1,184.25,385.59Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.25,385.59c-.28-1-1.19-1.33-2.29-.7l-74.79,42.95a5,5,0,0,0-2,1.6l-6.35-3.67A4.77,4.77,0,0,1,100.5,424l74.79-43a5.27,5.27,0,0,1,4.74,0l1.93,1.12A5.21,5.21,0,0,1,184.25,385.59Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.6,429.8l.72-.42a.21.21,0,0,1,.27,0,.48.48,0,0,1,.11.34v2.05a1.12,1.12,0,0,1-.11.47.71.71,0,0,1-.27.33l-1,.59-.22,2.35L118,435a.22.22,0,0,1,.27,0,.49.49,0,0,1,.11.35v2.05a1.19,1.19,0,0,1-.11.47.73.73,0,0,1-.27.32l-1.19.69-.18,1.92a1.21,1.21,0,0,1-.12.38.54.54,0,0,1-.23.26l-1.45.85a.18.18,0,0,1-.22,0,.38.38,0,0,1-.09-.28v0l.17-1.85-1,.59-.18,1.92a1.27,1.27,0,0,1-.12.39.58.58,0,0,1-.22.26l-1.46.84a.17.17,0,0,1-.22,0,.38.38,0,0,1-.09-.28v0l.17-1.85-.71.41a.2.2,0,0,1-.26,0,.46.46,0,0,1-.11-.34V440a1.12,1.12,0,0,1,.11-.47.62.62,0,0,1,.26-.32l1-.6.21-2.34-.88.51a.21.21,0,0,1-.26,0,.48.48,0,0,1-.11-.34v-2.05a1.12,1.12,0,0,1,.11-.47.7.7,0,0,1,.26-.33l1.2-.69.18-1.91a1.36,1.36,0,0,1,.11-.38.6.6,0,0,1,.22-.27l1.47-.84a.15.15,0,0,1,.21,0,.38.38,0,0,1,.1.28v.06l-.18,1.84,1-.6.18-1.92a1.09,1.09,0,0,1,.11-.38.52.52,0,0,1,.22-.26l1.47-.85a.16.16,0,0,1,.21,0,.38.38,0,0,1,.09.28V428Zm-3.67,7.54,1-.59.21-2.35-1,.6Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.14,420.49a.21.21,0,0,1,.27,0,.46.46,0,0,1,.11.34v13.79a1.12,1.12,0,0,1-.11.47.71.71,0,0,1-.27.33l-1.81,1.05a.21.21,0,0,1-.27,0,.48.48,0,0,1-.11-.34v-5.24l-3.08,1.78v5.23a1,1,0,0,1-.11.47.7.7,0,0,1-.26.33l-1.82,1.05a.22.22,0,0,1-.26,0,.47.47,0,0,1-.11-.35v-13.8a1.15,1.15,0,0,1,.11-.47.67.67,0,0,1,.26-.32l1.82-1.05a.2.2,0,0,1,.26,0,.42.42,0,0,1,.11.34v5.15l3.08-1.78v-5.15a1.19,1.19,0,0,1,.11-.47.8.8,0,0,1,.27-.32Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.82,431.31a5.83,5.83,0,0,1,.7-2.73,9.36,9.36,0,0,1,2.29-2.67l1.62-1.36a1.2,1.2,0,0,0-.18-.74q-.18-.22-.63,0a1.57,1.57,0,0,0-.49.42c-.11.16-.2.29-.26.4a1.62,1.62,0,0,1-.23.35,1.43,1.43,0,0,1-.27.19l-1.76,1a.19.19,0,0,1-.23,0c-.06-.05-.08-.15-.07-.3a4.13,4.13,0,0,1,.28-1.18,7.33,7.33,0,0,1,.68-1.38,8.7,8.7,0,0,1,1-1.35,5.6,5.6,0,0,1,1.31-1.05,3.42,3.42,0,0,1,1.47-.53,1.44,1.44,0,0,1,1,.29,1.94,1.94,0,0,1,.6,1,5.88,5.88,0,0,1,.19,1.61v6.47a1,1,0,0,1-.11.47.7.7,0,0,1-.26.33l-1.75,1a.2.2,0,0,1-.26,0,.46.46,0,0,1-.11-.35v-.6a6.37,6.37,0,0,1-.83,1.5,4.42,4.42,0,0,1-1.29,1.12,2.23,2.23,0,0,1-1.07.35,1.07,1.07,0,0,1-.77-.25,1.66,1.66,0,0,1-.48-.79A4.2,4.2,0,0,1,129.82,431.31ZM133,430a2,2,0,0,0,.57-.48,3.46,3.46,0,0,0,.46-.71,4.47,4.47,0,0,0,.31-.82,3.77,3.77,0,0,0,.11-.87l-1.28,1a2.67,2.67,0,0,0-.6.71,1.56,1.56,0,0,0-.23.79c0,.27.06.43.17.47A.61.61,0,0,0,133,430Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.54,423.79a.35.35,0,0,0-.1-.3.52.52,0,0,0-.36,0q-.24.06-.66.21t-1,.33a1.52,1.52,0,0,1-1.62-.26,2.8,2.8,0,0,1-.57-2,4.92,4.92,0,0,1,.24-1.48,7.38,7.38,0,0,1,.66-1.47,7.07,7.07,0,0,1,1-1.32,6.12,6.12,0,0,1,1.33-1,3.93,3.93,0,0,1,1.33-.5,2.09,2.09,0,0,1,1.05.08,1.32,1.32,0,0,1,.7.55,1.79,1.79,0,0,1,.29.92,1,1,0,0,1-.1.46.72.72,0,0,1-.28.33l-1.65,1a.25.25,0,0,1-.24,0l-.21-.12a.83.83,0,0,0-.33,0,1.31,1.31,0,0,0-.56.22,1.92,1.92,0,0,0-.53.44.88.88,0,0,0-.22.58.54.54,0,0,0,.07.33c.05.06.14.07.28,0s.33-.09.58-.17l1-.34c.85-.27,1.46-.19,1.84.25a2.86,2.86,0,0,1,.58,1.95,5,5,0,0,1-.24,1.49,7,7,0,0,1-.69,1.51,8.53,8.53,0,0,1-1.11,1.4,7.31,7.31,0,0,1-1.49,1.13,4,4,0,0,1-1.46.56,1.89,1.89,0,0,1-1.06-.13,1.38,1.38,0,0,1-.66-.6,2.09,2.09,0,0,1-.26-.9,1,1,0,0,1,.11-.46.77.77,0,0,1,.27-.33l1.72-1c.1-.06.17-.06.22,0l.18.15a.58.58,0,0,0,.32.07,1.4,1.4,0,0,0,.62-.24,3,3,0,0,0,.73-.59A1,1,0,0,0,142.54,423.79Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.65,420.13a1.12,1.12,0,0,1-.11.47.7.7,0,0,1-.26.33l-1.75,1a.2.2,0,0,1-.26,0,.44.44,0,0,1-.12-.34v-5.41a2.17,2.17,0,0,0-.29-1.3c-.19-.26-.5-.27-.91,0a2.07,2.07,0,0,0-.91,1.08,4.44,4.44,0,0,0-.29,1.64V423a1,1,0,0,1-.11.47.67.67,0,0,1-.26.32l-1.75,1a.19.19,0,0,1-.26,0,.46.46,0,0,1-.11-.34v-14a1.11,1.11,0,0,1,.11-.46.7.7,0,0,1,.26-.33l1.75-1a.2.2,0,0,1,.26,0,.44.44,0,0,1,.11.34v4.55a6.83,6.83,0,0,1,.74-1.29,3.66,3.66,0,0,1,1.15-1.08,3,3,0,0,1,1.22-.42,1.26,1.26,0,0,1,.95.34,2.44,2.44,0,0,1,.62,1.16,7.72,7.72,0,0,1,.22,2.05Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.45,413.61a1.11,1.11,0,0,0,.14.67c.09.13.24.13.46,0l1.1-.64a.2.2,0,0,1,.27,0,.46.46,0,0,1,.11.34v2.15a1.12,1.12,0,0,1-.11.47.71.71,0,0,1-.27.33l-1.31.76a2.59,2.59,0,0,1-1.19.39,1.24,1.24,0,0,1-.91-.31,2.06,2.06,0,0,1-.58-1,5.5,5.5,0,0,1-.21-1.64v-3.59l-1,.59a.21.21,0,0,1-.27,0,.46.46,0,0,1-.11-.34v-2.16a1.19,1.19,0,0,1,.11-.47.73.73,0,0,1,.27-.32l1-.59V404.8a1.15,1.15,0,0,1,.11-.47.68.68,0,0,1,.27-.32l1.74-1a.21.21,0,0,1,.27,0,.51.51,0,0,1,.11.35v3.48l1.57-.91a.2.2,0,0,1,.26,0,.48.48,0,0,1,.11.34v2.16a1.15,1.15,0,0,1-.11.47.67.67,0,0,1-.26.32l-1.57.91Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.24,413.17a5.72,5.72,0,0,1,.7-2.73,9.13,9.13,0,0,1,2.28-2.66l1.62-1.37a1.2,1.2,0,0,0-.18-.74c-.12-.15-.33-.14-.62,0a1.5,1.5,0,0,0-.49.43,2.37,2.37,0,0,0-.26.39,1.17,1.17,0,0,1-.24.35,1,1,0,0,1-.26.19l-1.76,1a.21.21,0,0,1-.23,0,.37.37,0,0,1-.08-.3,4.12,4.12,0,0,1,.28-1.19,8.07,8.07,0,0,1,.69-1.38,8.49,8.49,0,0,1,1-1.34,5.4,5.4,0,0,1,1.31-1.06,3.47,3.47,0,0,1,1.47-.53,1.42,1.42,0,0,1,1,.29,2,2,0,0,1,.61,1,6.15,6.15,0,0,1,.19,1.6v6.48a1.11,1.11,0,0,1-.11.46.71.71,0,0,1-.27.33l-1.74,1a.22.22,0,0,1-.27,0,.48.48,0,0,1-.11-.34v-.6A6.88,6.88,0,0,1,165,414a4.21,4.21,0,0,1-1.3,1.12,2.34,2.34,0,0,1-1.06.36,1.1,1.1,0,0,1-.78-.26,1.74,1.74,0,0,1-.48-.79A4.17,4.17,0,0,1,161.24,413.17Zm3.16-1.33a2.33,2.33,0,0,0,.57-.49,3.85,3.85,0,0,0,.46-.7,3.91,3.91,0,0,0,.3-.83,3.7,3.7,0,0,0,.11-.87l-1.27,1a2.91,2.91,0,0,0-.61.71,1.56,1.56,0,0,0-.23.79c0,.27.06.43.18.47A.65.65,0,0,0,164.4,411.84Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.3,410.86a2.87,2.87,0,0,0,.93-.91,2.38,2.38,0,0,0,.4-1.35v-1.5c-.08.21-.17.41-.27.62a3.24,3.24,0,0,1-.36.61,4.06,4.06,0,0,1-.52.6,4.4,4.4,0,0,1-.77.57,2.69,2.69,0,0,1-1.18.39,1.31,1.31,0,0,1-1-.33,2.59,2.59,0,0,1-.68-1.1,6.73,6.73,0,0,1-.28-1.95c0-.21,0-.46,0-.75s0-.55,0-.77a11,11,0,0,1,.28-2.29,9.2,9.2,0,0,1,.68-1.88,6.33,6.33,0,0,1,1-1.45,4.84,4.84,0,0,1,1.18-1,3,3,0,0,1,.79-.33,1.57,1.57,0,0,1,.57,0,.92.92,0,0,1,.38.2,1.23,1.23,0,0,1,.25.27V398a1.15,1.15,0,0,1,.11-.47.68.68,0,0,1,.27-.32l1.61-.93a.2.2,0,0,1,.26,0,.46.46,0,0,1,.11.34v10.4a8.75,8.75,0,0,1-.28,2.26,8.2,8.2,0,0,1-.79,2,7.32,7.32,0,0,1-1.19,1.6,7.48,7.48,0,0,1-1.52,1.18,3.53,3.53,0,0,1-1.77.6,1.59,1.59,0,0,1-1.08-.38,1.9,1.9,0,0,1-.54-.92,3.84,3.84,0,0,1-.16-1,.91.91,0,0,1,.1-.47.8.8,0,0,1,.27-.32l1.8-1c.2-.11.34-.06.43.18a.65.65,0,0,0,.3.31C172.77,411.1,173,411,173.3,410.86Zm-1.22-7.09c0,.22,0,.4,0,.54a5.08,5.08,0,0,0,0,.51,1.64,1.64,0,0,0,.34,1c.2.21.5.2.91,0a2.12,2.12,0,0,0,.87-1,4,4,0,0,0,.36-1.31,6,6,0,0,0,0-1.34,1.32,1.32,0,0,0-.35-.88c-.21-.2-.5-.19-.88,0a2.14,2.14,0,0,0-.9,1A4,4,0,0,0,172.08,403.77Z",
    style: {
      fill: "#FB923C"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--hashtag-bubble--inject-68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181,101.08l-3.21-6,2.58-7.45V83l-7.9,4.56v4.56l3.4,5.88a.51.51,0,0,0,.23.21h0Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,101.08l-3.21-6,2.58-7.45V83l-7.9,4.56v4.56l3.4,5.88a.51.51,0,0,0,.23.21h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.29,34.11a5.22,5.22,0,0,0-2.37-4.1L236,28.89a5.27,5.27,0,0,0-4.74,0l-74.79,43a5.24,5.24,0,0,0-2.37,4.1V98a5.24,5.24,0,0,0,2.37,4.11l1.93,1.11a5.21,5.21,0,0,0,4.74,0L177.45,95l3.39,5.87a.51.51,0,0,0,.92-.08l3.58-10.34,52.58-30.21a5.22,5.22,0,0,0,2.37-4.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.62,29.22a4.08,4.08,0,0,1,1.93.44l1.92,1.12a4.38,4.38,0,0,1,1.93,3.33V56.17a4.4,4.4,0,0,1-1.92,3.33L184.9,89.7l-.29.17-.11.31-3.31,9.54-3-5.13-.45-.77-.77.44-14.33,8.19a4.41,4.41,0,0,1-3.84,0l-1.93-1.12A4.36,4.36,0,0,1,155,98V75.94a4.39,4.39,0,0,1,1.92-3.33L231.7,29.66a4,4,0,0,1,1.92-.44m0-.9a4.86,4.86,0,0,0-2.37.57l-74.79,43a5.24,5.24,0,0,0-2.37,4.1V98a5.24,5.24,0,0,0,2.37,4.11l1.93,1.11a5.21,5.21,0,0,0,4.74,0L177.45,95l3.39,5.87a.49.49,0,0,0,.44.26.51.51,0,0,0,.48-.34l3.58-10.34,52.58-30.21a5.22,5.22,0,0,0,2.37-4.1V34.11a5.22,5.22,0,0,0-2.37-4.1L236,28.89a4.8,4.8,0,0,0-2.37-.57Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.09,98a5.24,5.24,0,0,0,2.37,4.11l1.93,1.11a5.3,5.3,0,0,0,4.33.19c-1.11.42-2-.21-2-1.56V80.44a6.63,6.63,0,0,1,.38-3.15l-6.35-3.68a4.83,4.83,0,0,0-.7,2.33Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.09,98a5.24,5.24,0,0,0,2.37,4.11l1.93,1.11a5.3,5.3,0,0,0,4.33.19c-1.11.42-2-.21-2-1.56V80.44a6.63,6.63,0,0,1,.38-3.15l-6.35-3.68a4.83,4.83,0,0,0-.7,2.33Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.21,33.43c-.27-1-1.19-1.32-2.29-.69L163.13,75.69a5.11,5.11,0,0,0-2,1.6l-6.34-3.68a4.71,4.71,0,0,1,1.66-1.76l74.79-43a5.27,5.27,0,0,1,4.74,0L237.92,30A5.21,5.21,0,0,1,240.21,33.43Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.21,33.43c-.27-1-1.19-1.32-2.29-.69L163.13,75.69a5.11,5.11,0,0,0-2,1.6l-6.34-3.68a4.71,4.71,0,0,1,1.66-1.76l74.79-43a5.27,5.27,0,0,1,4.74,0L237.92,30A5.21,5.21,0,0,1,240.21,33.43Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.56,77.65l.73-.42a.2.2,0,0,1,.26,0,.48.48,0,0,1,.11.34v2a1.12,1.12,0,0,1-.11.47.62.62,0,0,1-.26.32l-1,.6L173,83.38l.89-.52a.2.2,0,0,1,.26,0,.48.48,0,0,1,.11.34v2a1.12,1.12,0,0,1-.11.47.76.76,0,0,1-.26.33l-1.2.68-.18,1.92a1.27,1.27,0,0,1-.12.39.58.58,0,0,1-.22.26l-1.46.84a.17.17,0,0,1-.22,0,.38.38,0,0,1-.09-.28v0l.17-1.85-1,.59-.18,1.92a1,1,0,0,1-.11.39.59.59,0,0,1-.23.26L167.6,92a.16.16,0,0,1-.21,0,.39.39,0,0,1-.09-.28v0l.16-1.84-.71.41a.21.21,0,0,1-.26,0,.48.48,0,0,1-.11-.34v-2a1.12,1.12,0,0,1,.11-.47.7.7,0,0,1,.26-.33l1-.59.21-2.34-.87.5a.2.2,0,0,1-.27,0,.46.46,0,0,1-.11-.34v-2a1.19,1.19,0,0,1,.11-.47.73.73,0,0,1,.27-.32l1.19-.69.18-1.92a1.3,1.3,0,0,1,.11-.37.55.55,0,0,1,.22-.27l1.47-.85a.18.18,0,0,1,.22,0,.38.38,0,0,1,.09.28v.06l-.18,1.84,1-.61.18-1.91a1.36,1.36,0,0,1,.11-.38.6.6,0,0,1,.22-.27l1.47-.84a.15.15,0,0,1,.21,0,.34.34,0,0,1,.1.28v.06Zm-3.67,7.54,1-.6.21-2.34-1,.59Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.64,87.59a.19.19,0,0,1-.26,0,.46.46,0,0,1-.11-.34V73.44a1.15,1.15,0,0,1,.11-.47.67.67,0,0,1,.26-.32l4.47-2.58a3,3,0,0,1,1.57-.51,1.45,1.45,0,0,1,1,.43,2.5,2.5,0,0,1,.54,1.12,6.54,6.54,0,0,1,.17,1.49,6.47,6.47,0,0,1-.09,1.13,8.45,8.45,0,0,1-.21.92,6.15,6.15,0,0,1-.26.68c-.09.19-.16.33-.22.43a1.49,1.49,0,0,1,.76.9,5.56,5.56,0,0,1,.21,1.7,10.31,10.31,0,0,1-.16,1.81,8.14,8.14,0,0,1-.55,1.8,6.77,6.77,0,0,1-1,1.62,5.59,5.59,0,0,1-1.5,1.26Zm5.19-13.41a1,1,0,0,0-.21-.76c-.15-.14-.36-.13-.64,0l-2.14,1.24v2.44L181,75.88a1.59,1.59,0,0,0,.64-.69A2.4,2.4,0,0,0,181.83,74.18Zm-3,8.84,2.28-1.32a1.73,1.73,0,0,0,.67-.76,2.4,2.4,0,0,0,.25-1.07,1,1,0,0,0-.25-.79c-.17-.15-.39-.15-.67,0l-2.28,1.32Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.91,71.72a1.12,1.12,0,0,1,.11-.47.7.7,0,0,1,.26-.33l1.75-1a.21.21,0,0,1,.26,0,.45.45,0,0,1,.12.35v5.4a2.47,2.47,0,0,0,.26,1.32c.17.27.47.28.87,0a2,2,0,0,0,.87-1.06,4.7,4.7,0,0,0,.26-1.62V69a1,1,0,0,1,.11-.47.62.62,0,0,1,.26-.32l1.75-1a.2.2,0,0,1,.26,0,.42.42,0,0,1,.11.34v10a1,1,0,0,1-.11.47.67.67,0,0,1-.26.32l-1.61.93a.2.2,0,0,1-.26,0,.43.43,0,0,1-.12-.34v-.49a5.31,5.31,0,0,1-.27.62,3.59,3.59,0,0,1-.39.63,4.46,4.46,0,0,1-.55.61,4,4,0,0,1-.74.55c-.9.52-1.61.54-2.14.06s-.8-1.55-.8-3.23Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.27,62.83a1.15,1.15,0,0,1-.11.47.68.68,0,0,1-.27.32l-1.74,1a.2.2,0,0,1-.27,0,.46.46,0,0,1-.11-.34V62.12a1.2,1.2,0,0,1,.11-.48.73.73,0,0,1,.27-.32l1.74-1a.22.22,0,0,1,.27,0,.48.48,0,0,1,.11.34Zm0,12.28a1.15,1.15,0,0,1-.11.47.68.68,0,0,1-.27.32l-1.74,1a.21.21,0,0,1-.27,0,.46.46,0,0,1-.11-.34v-10a1.15,1.15,0,0,1,.11-.47.68.68,0,0,1,.27-.32l1.74-1a.21.21,0,0,1,.27,0,.46.46,0,0,1,.11.34Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.37,72.74a1,1,0,0,1-.11.47.67.67,0,0,1-.26.32l-1.75,1a.2.2,0,0,1-.26,0,.42.42,0,0,1-.11-.34v-14a1,1,0,0,1,.11-.47.72.72,0,0,1,.26-.32l1.75-1a.2.2,0,0,1,.26,0,.42.42,0,0,1,.11.34Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.81,59.44a2,2,0,0,1,.71-.28,1.17,1.17,0,0,1,.53,0,1,1,0,0,1,.37.2,2.05,2.05,0,0,1,.25.27V55.1a1.12,1.12,0,0,1,.11-.47.7.7,0,0,1,.26-.33l1.75-1a.21.21,0,0,1,.27,0,.48.48,0,0,1,.11.34v14a1.12,1.12,0,0,1-.11.47.77.77,0,0,1-.27.33l-1.68,1a.2.2,0,0,1-.26,0,.51.51,0,0,1-.11-.35v-.49c-.08.21-.18.41-.27.62a4.86,4.86,0,0,1-.36.61,3.68,3.68,0,0,1-.53.6,4.05,4.05,0,0,1-.77.57,2.65,2.65,0,0,1-1.18.39,1.29,1.29,0,0,1-1-.34,2.48,2.48,0,0,1-.67-1.14,7,7,0,0,1-.29-2c0-.21,0-.49,0-.86s0-.65,0-.87A11.17,11.17,0,0,1,203,63.8a9.21,9.21,0,0,1,.67-1.92,6.51,6.51,0,0,1,1-1.46A4.8,4.8,0,0,1,205.81,59.44ZM205.19,65a8,8,0,0,0,0,1.2,2.16,2.16,0,0,0,.32,1.12c.18.26.49.27.92,0a1.8,1.8,0,0,0,.53-.46,2.62,2.62,0,0,0,.37-.6,4.19,4.19,0,0,0,.23-.68,5.65,5.65,0,0,0,.11-.68c0-.23,0-.48,0-.77s0-.53,0-.73a2.82,2.82,0,0,0-.11-.55,1.2,1.2,0,0,0-.23-.42.53.53,0,0,0-.37-.18,1,1,0,0,0-.53.15,2.12,2.12,0,0,0-.92,1.1A4.67,4.67,0,0,0,205.19,65Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.27,53a1.12,1.12,0,0,1-.11.47.7.7,0,0,1-.26.33l-1.75,1a.21.21,0,0,1-.26,0,.45.45,0,0,1-.12-.34V52.3a1,1,0,0,1,.12-.47.62.62,0,0,1,.26-.32l1.75-1a.2.2,0,0,1,.26,0,.51.51,0,0,1,.11.35Zm0,12.28a1.12,1.12,0,0,1-.11.47.7.7,0,0,1-.26.33l-1.75,1a.2.2,0,0,1-.26,0,.46.46,0,0,1-.12-.35v-10a1.06,1.06,0,0,1,.12-.47.72.72,0,0,1,.26-.32l1.75-1a.2.2,0,0,1,.26,0,.48.48,0,0,1,.11.34Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.27,60.1a1.11,1.11,0,0,1-.11.46.7.7,0,0,1-.26.33l-1.75,1a.2.2,0,0,1-.26,0,.44.44,0,0,1-.11-.34V56.13a2.16,2.16,0,0,0-.3-1.3c-.19-.26-.5-.27-.91,0a2.07,2.07,0,0,0-.91,1.08,4.44,4.44,0,0,0-.28,1.64v5.4a1.12,1.12,0,0,1-.11.47.77.77,0,0,1-.27.33l-1.75,1a.2.2,0,0,1-.26,0,.51.51,0,0,1-.11-.35v-10a1.19,1.19,0,0,1,.11-.47.72.72,0,0,1,.26-.32l1.68-1a.21.21,0,0,1,.27,0,.48.48,0,0,1,.11.34v.49c.07-.18.16-.39.27-.61a4.66,4.66,0,0,1,.41-.65,5,5,0,0,1,.54-.61,3.74,3.74,0,0,1,.73-.54,2.88,2.88,0,0,1,1.22-.41,1.21,1.21,0,0,1,1,.33,2.49,2.49,0,0,1,.62,1.16,7.72,7.72,0,0,1,.22,2Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.24,59.3a2.87,2.87,0,0,0,.93-.91,2.38,2.38,0,0,0,.4-1.35v-1.5c-.08.21-.17.41-.27.62a4.86,4.86,0,0,1-.36.61,4.15,4.15,0,0,1-.53.6,4.05,4.05,0,0,1-.77.57,2.65,2.65,0,0,1-1.18.39,1.32,1.32,0,0,1-1-.33,2.49,2.49,0,0,1-.67-1.1,6.69,6.69,0,0,1-.29-1.95c0-.21,0-.46,0-.75s0-.55,0-.77a10.94,10.94,0,0,1,.29-2.29,8.64,8.64,0,0,1,.67-1.88,6.67,6.67,0,0,1,1-1.45,5,5,0,0,1,1.18-1,3.19,3.19,0,0,1,.79-.33,1.36,1.36,0,0,1,.57,0,.8.8,0,0,1,.39.19,2.05,2.05,0,0,1,.25.27v-.49a1.15,1.15,0,0,1,.11-.47.62.62,0,0,1,.26-.32l1.61-.93a.21.21,0,0,1,.27,0,.46.46,0,0,1,.11.34v10.4a8.75,8.75,0,0,1-.29,2.26,8.61,8.61,0,0,1-.78,2,7.32,7.32,0,0,1-1.19,1.6,7.54,7.54,0,0,1-1.53,1.18,3.47,3.47,0,0,1-1.77.6,1.56,1.56,0,0,1-1.07-.38,1.9,1.9,0,0,1-.54-.92,3.88,3.88,0,0,1-.17-1,.91.91,0,0,1,.1-.47A.8.8,0,0,1,225,60l1.81-1c.19-.11.34-.06.43.18a.57.57,0,0,0,.3.31C227.7,59.54,227.92,59.48,228.24,59.3ZM227,52.21q0,.33,0,.54t0,.51a1.64,1.64,0,0,0,.34,1c.2.21.5.2.91,0a2.1,2.1,0,0,0,.86-1A4.23,4.23,0,0,0,229.5,52a6,6,0,0,0,0-1.34,1.38,1.38,0,0,0-.36-.88q-.3-.3-.87,0a2.21,2.21,0,0,0-.91,1A4,4,0,0,0,227,52.21Z",
    style: {
      fill: "#FB923C"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--big-hashtag--inject-68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hashtag--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.05,51.15,259.39,73.46,259.26,136l-8.72,5,.09-37.51L231.91,89.33l-38.65,22.31.17,62.32-34.12,19.7-8.93,53.06,18.72,14.15,23.65-13.65-.18,16.22-35.94,20.74-8.25,49.05,18.72,14.15,25.3-14.61-.14,41.16L211,388.08l38.65-22.31-.1-66,9-5.2-.14,41.16,18.72,14.15,38.65-22.32-.09-66,37.74-21.8,8.25-49.05L343,176.61l-27,15.58.18-16.22,39.25-22.67,8.93-53.06L345.62,86.09l-29.15,16.83.29-37.63ZM258.88,209l-.18,16.23-8.86,5.11.19-16.23Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.76,217.26l.4-41.29,39.25-22.67,8.93-53.06-48,27.72.44-62.67L278.11,87.61,278,150.1,250.49,166l.14-62.49L212,125.79l.16,62.32L178,207.81l-8.92,53.06,42.57-24.58-.39,41.29-35.93,20.75-8.25,49.05,44.08-25.45-.2,66.15,38.65-22.32-.1-66,27.79-16-.21,66.15,38.65-22.32-.09-66,37.74-21.8,8.25-49.05ZM277.41,239.4l-27.78,16,.4-41.29,27.78-16Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.75,67,315.32,128v1.75l1.51-.88L363,102.16l-8.49,50.51L315.66,175.1l-.5.28V176l-.4,41.29,0,1.75,1.52-.87,44.06-25.44-7.82,46.49-37.33,21.56-.51.29v.58l.09,65.4-36.65,21.15.21-64.41V282l-1.5.87-27.79,16-.5.29v.58l.1,65.4L212,386.34l.2-64.41v-1.74l-1.51.87-42.25,24.39L176.25,299l35.53-20.51.49-.29v-.57l.39-41.29,0-1.75-1.52.87-40.74,23.52,8.5-50.5L212.64,189l.5-.29v-.58L213,126.37l36.64-21.16L249.49,166v1.74l1.5-.87L278.47,151l.5-.28v-.58l.14-61.91L315.75,67M248.61,257.19l1.52-.88,27.78-16,.5-.29v-.57l.4-41.29v-1.76l-1.51.88-27.78,16-.5.28v.58l-.4,41.29,0,1.76m68.15-191.9L278.11,87.61,278,150.1,250.49,166l.14-62.49L212,125.79l.16,62.32L178,207.81l-8.92,53.06,42.57-24.58-.39,41.29-35.93,20.75-8.25,49.05,44.08-25.45-.2,66.15,38.65-22.32-.1-66,27.79-16-.21,66.15,38.65-22.32-.09-66,37.74-21.8,8.25-49.05-45.9,26.5.4-41.29,39.25-22.67,8.93-53.06-48,27.72.44-62.67ZM249.63,255.44l.4-41.29,27.78-16-.4,41.29-27.78,16Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.76,217.26l.4-41.29,39.25-22.67,8.93-53.06-48,27.72.44-62.67L278.11,87.61,278,150.1,250.49,166l.14-62.49L212,125.79l.16,62.32L178,207.81l-8.92,53.06,42.57-24.58-.39,41.29-35.93,20.75-8.25,49.05,44.08-25.45-.2,66.15,38.65-22.32-.1-66,27.79-16-.21,66.15,38.65-22.32-.09-66,37.74-21.8,8.25-49.05ZM277.41,239.4l-27.78,16,.4-41.29,27.78-16Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.1 347.38 175.34 298.33 156.63 284.18 148.38 333.23 167.1 347.38",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.28 277.58 192.56 263.44 192.75 247.22 211.67 236.29 211.28 277.58",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,207.81l-18.71-14.15-8.93,53.06,18.72,14.15Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,125.79l-18.72-14.15.17,62.32,18.71,14.15Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.41 239.4 258.7 225.26 258.88 209.03 277.81 198.11 277.41 239.4",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.26 135.95 277.97 150.1 278.11 87.61 259.39 73.46 259.26 135.95",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.11 349.9 277.32 283.75 258.53 294.59 258.39 335.75 277.11 349.9",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.98 388.08 211.18 321.93 192.4 332.77 192.26 373.93 210.98 388.08",
    style: {
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409,97l2.63-5L409.5,86V82.25L416,86v3.74l-2.79,4.83a.37.37,0,0,1-.19.16h0Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409,97l2.63-5L409.5,86V82.25L416,86v3.74l-2.79,4.83a.37.37,0,0,1-.19.16h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.52,52.52a4.3,4.3,0,0,1,1.94-3.36l1.58-.91a4.3,4.3,0,0,1,3.89,0l24.24,14a4.29,4.29,0,0,1,1.94,3.36V92.31a4.29,4.29,0,0,1-1.94,3.36l-1.58.91a4.28,4.28,0,0,1-3.88,0l-7.8-4.5-2.78,4.81a.41.41,0,0,1-.75-.07l-2.94-8.48-10-5.78a4.29,4.29,0,0,1-1.94-3.36Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.11,92.31a4.29,4.29,0,0,1-1.94,3.36l-1.58.91a4.34,4.34,0,0,1-3.55.16c.91.35,1.61-.17,1.61-1.28V68.79a4,4,0,0,0-.57-1.92l5.46-3.15a3.87,3.87,0,0,1,.57,1.91Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.58,52c.23-.82,1-1.09,1.88-.57l24.25,14a3.84,3.84,0,0,1,1.37,1.45l5.46-3.16a4.08,4.08,0,0,0-1.37-1.45l-24.24-14a4.3,4.3,0,0,0-3.89,0l-1.58.91A4.37,4.37,0,0,0,393.58,52Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--heart--inject-68",
    d: "M407.91,84.05c8.34-2,9-8.92,6.55-13.87-2.18-4.44-6.15-4.61-6.58-.3-.46-4.82-4.44-9.21-6.61-7.26C398.85,64.79,399.54,72.47,407.91,84.05Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildinghashtagAmico);
export default __webpack_public_path__ + "static/media/Building hashtag-amico.b52d8986237080985d3680f7790bb32b.svg";
export { ForwardRef as ReactComponent };